import { MateSpriteDirection } from "../enums/game";
import {
  DispatchDifficultyLevel,
  MateDispatchStatusRequest,
} from "../enums/mission";
import {
  goldTicketRules,
  rankRules,
  seniorReaderRules,
} from "./zhCn/rankRules";
import { tag } from "./zhCn/tag";
import {
  BillingCycle,
  MemberType,
  MemoryCapacityLevel,
  MemoryCapacityLevelMap,
  MemoryType,
  UserTaskStatus,
  UserTaskType,
} from "@/enums/mateEnums";
import { LanguageModel } from "@/enums/chatEnums";
import { ChestType, PowerCubeTransactionCategory } from "@/types/user";

const Menus = {
  settings: "个性化设置",
  mates: "伙伴",
  notifications: "通知",
  androidDownload: "下载安卓版",
};
const User = {
  dataCompleteness: "资料完成度",
  superAdmire: "高级订阅",
  timeLimitedFree: "限时免费",
  fillName: "更改角色昵称",
  shareAuthor: "分享作者",
  creator: "创作者",
  universe: "宇宙",
  home: {
    like: "收到的喜欢",
    following: "关注",
    followed: "已关注",
    oc: "Ta的OC",
    myOc: "我的OC",
    universe: "全部星球",
    noOc: "Ta还没有可见的OC",
    story: "故事",
    novel: "视觉小说",
    moment: "饼友圈",
  },
  guardStatus: {
    1: "限时免费",
    2: "限时免费",
    3: "限时免费",
    4: "${amount} / 月",
  },
  login: "登录",
  register: "注册",
  signout: "登出",
  uploadAvatarHelp: "点击上传新的个人头像",
  currentTokens: "当前令牌：",
  tokens: "令牌数",
  mates: "伙伴数",
  bio: "简介",
  bioPlaceholder: "社区其他人将会看到您的介绍",
  model: "模型",
  apiKey: "API 秘钥",
  apiKeyPlaceholder: "使用 API 密钥将不再花费令牌",
  openAiKey: "OpenAI 秘钥",
  currentMate: "当前的角色",
  mate: {
    isNsfwVisible: "是否显示 NSFW 内容",
    isNsfwBlurry: "是否模糊 NSFW 内容",
    selectRole: "选择身份",
    selectCharacter: "选择角色",
    selectCharacterToCreate: "想为哪个角色进行创作?",
    selectRoleDesc: "选择一个身份与其他角色互动",
    selectWorldView: "选择星球",
    draft: "草稿",
    preset: "样例",
    removeAllPreset: "删除所有样例",
    unnamed: "未命名",
    following: "关注中",
    addFriend: "添加好友",
    hasBeenFriend: "已成为好友",
    friendRequested: "已申请好友",
    completeProfile: "完善资料",
    currentSelected: "当前角色",
    follow: "关注",
    chatString: "聊天",
    guarding: "守护中",
    guard: "守护",
    guardianshipApplied: "已申请",
    noWorldView: "暂无星球，请先创作。",
    basicInfo: {
      title: "基本信息",
      name: "姓名",
      type: "类型",
      gender: "性别",
      age: "年龄",
      tag: "特征标签",
      bio: "一句话介绍",
      intro: "场景介绍",
      birthday: "生日",
      race: "种族",
      occupation: "职业/身份",
      personality: "性格设定",
      worldview: "星球",
      bornPlanet: "母星",
      currentPlanet: "所在星球",
      planet: "星球",
      relationWithMe: "与我的关系",
      personalityPrompt: "性格设定",
      mbti: "MBTI 类型",
      // placeholder: {
      //   name: "[必填] 角色的名字",
      //   type: "[必填] 角色的类型",
      //   gender: "角色的性别",
      //   age: "年龄",
      //   bio: "简介",
      //   tag: "为您的角色打标签，最多选择7个标签",
      //   intro: "仅用于公开展示，描述在当前场景中你希望玩家做什么？",
      //   birthday: "生日",
      //   personality: "性格设定",
      //   race: "种族",
      //   occupation: "职业",
      // },

      rules: {
        name: "请填写角色姓名",
        type: "请填写角色类型",
        gender: "请填写角色性别",
        age: "",
        bio: "",
        tag: "最多选择7个标签",
      },
    },

    module: {
      create: "新增模块",
      appearance: "外观",
      personality: "",
      tone: "音色",
      visibility: "可见性",
      chat: "聊天",
      chatPrompt: "聊天提示词",
      chatEmotionPic: "聊天表情图片",
      chatImage: "自拍",
      createCustom: "创作自定义模块",
      name: "模块名称",
      chatScene: "场景",
      persona: "人格注入",
      basicInfo: "基本信息",
      sprite: "形象",
      game: "视觉小说",
      feature: "为Ta捏图",
      gallery: "稿件",
      story: "故事集",
      moment: "星辰日志",
      task: "生图队列",
      bgStory: "背景故事",
      relation: "人际关系",
      collection: "设定合集",
      prop: "属性",
      relationship: "关系",
      chatList: "与OC对话",
      ocSetting: "OC设定",
      ocInteractive: "OC互动",
      roleplay: "答题",
      timeline: "时间线",
      memory: "记忆",
      driftCapsule: "漂流仓",
    },

    bgStory: {
      editWorldView: "编辑星球",
      worldViewName: "星球名称",
      enterWorldViewName: "星球名称",
      worldViewDescription: "星球描述",
      enterWorldViewDescription: "星球描述",
      personalExperience: "个人经历",
      noWorldView: "暂无星球，请先创作。",
      //关联故事集
      relatedStorybook: "关联故事集",
      replaceStorybook: "替换故事集",
    },

    relation: {
      myRelation: "与我的关系",
      friend: "好友关系",
      enemy: "敌对关系",
      custom: "添加自定义关系",
      addRelation: "关联其他 OC",
    },

    appearance: {
      avatar: "头像",
      coverImage: "封面图片",
      bannerImage: "横幅图片",
      characterTraits: "角色特征",
      scene: "聊天背景图",
    },
    toneType: "音色类型",
    selectTone: "选择音色",

    setting: "设置",
    privacySettings: "隐私设置",
    visibility: {
      public: "公开",
      onlyFollower: "仅关注者",
      private: "隐藏",

      dynamicVisibilitySettings: "饼友圈可见设置",
      visibility: "角色可见性",
      isAllowedInjection: "是否允许关系注入",
      allowInjection: "允许",
      notAllowInjection: "不允许",
      isUnfiltered: "这是一个未审查的角色？",
      filtered: "受审查",
      unfiltered: "未审查",
      dangerZone: "危险区",
      dangerZoneHelp: "最后一个已发布的角色不能删除",
    },
    chat: {
      chatSettings: "聊天设置",
      chatPromptSetting: "聊天提示词设置",
      allowSwitchingToNSFW: "允许切换到NSFW聊天",
      onlyVisibilityToYou: "以下内容仅对你可见",
      systemPrompt: "系统提示词",
      systemPromptTip:
        "系统提示词可以帮助模型强化角色的行为和聊天风格，如：避免重复{'{{user}}'}的消息，只允许{'{{char}}'}回复与{'{{char}}'}相关的内容",
      personality: "编写OC设定",
      personalityPlaceholder: `角色核心特质、行为和态度的简明描述，为一致的互动奠定基础。`,
      greetingMessage: "第一条消息",
      greetingMessagePlaceholder: `第一条消息非常重要，它准确地设定了角色的沟通方式和风格。

角色的第一条消息应该很长，这样以后角色就不太可能回复非常短的消息。

您还可以使用星号**来描述角色的动作。

例如：

*我注意到你进来了，我走上前站在你面前*欢迎。我很高兴在这里见到你。 *我说时带着露齿自鸣得意的阳光微笑，直视着你的眼睛*是什么给你带来了......`,
      scenario: "场景",
      scenarioTip:
        "对话的情况和背景。描述一个你的角色会参与其中的场景。为了更好的沉浸感，尝试将场景描述得好像它正在发生",
      chatExample: "聊天样例",
      chatExamplePlaceholder: "用于帮助角色调整语言风格",
      example: "样例",
      pleaseUserInput: "请填写用户输入",
      userInput: "用户输入",
      simulatedUserInputText: "模拟用户输入的文本",
      pleaseCharacterReply: "请输入角色回复",
      characterReply: "角色回复",
      textCharacterReply: "希望角色回复的文本",
      tips: "小技巧",
      placeholderTips:
        "您可以输入{'{{char}}'}和{'{{user}}'}，这两个变量来使用编排角色和用户之间的故事，在聊天时系统将自动将这两个变量转换为角色和用户的名称。\n例如输入：{'{{char}}'}和{'{{user}}'}是一对情侣。\n当前角色为'小魔女'，用户角色为'夏洛克'时。\n以上提示词在聊天时会被解析为：'小魔女和夏洛克是一对情侣'",
    },

    attribute: {
      createCustom: "创作自定义属性",
      updateCustom: "更新自定义属性名称",
      name: "属性名称",
    },

    tone: {
      current: "当前OC音色",
      speed: "语速",
      selectSpeed: "选择语速",
      speedValue: "语速值",
      value: "值",
      customInputLabel: "输入文字（200字以内）",
      customTryListen: "自定义试听",
      emotionTitle: "情感",
      emotionValue: "情感值",
      selectEmotion: "选择情感",
      selectEmotionValue: "选择情感值",
      emotion: {
        1: "开心",
        2: "悲伤",
        3: "愤怒",
        4: "害怕",
        5: "兴奋",
        6: "冷漠",
        7: "平静",
        8: "惊讶",
        9: "厌恶",
      },
    },

    driftCapsule: {
      title: "漂流仓",
      all: "全部",
      salvageableArea: "可打捞领域",
      salvagedArea: "已唤醒",
      salvageable: "可打捞",
      salvaged: "已打捞",
    },

    mySetting: "我的自设",

    viewMode: {
      portrait: "立绘模式",
      avatar: "列表模式",
    },
  },

  gallery: {
    all: "全部",
  },

  admire: {
    name: "守护",
    whoCanAdmire: "谁可以守护我？",
    tips: "如果允许其他人守护你，对方在成功守护之后将成为共创者，并可以在创作故事或游戏时使用你的角色进行共同创作。",
    permission: {
      1: "无人",
      2: "任何人无需权限",
      3: "任何获得我的许可的人",
      4: "付费守护我",
    },

    // 高级订阅
    super: "高级订阅",
    superContent: `启用此功能后，饼次元不再对高级订阅用户与您的伙伴进行私聊时的内容进行限制和审查。`,
    superTip: `儿童类型的伙伴设计无法激活此功能。`,
    superApply: "申请启用",

    receivedContent: `我们正在审核您的申请。

我们将通过电子邮件和站内通知向您通知结果`,
    enabled: "已启用",
    disabled: "已禁用",
    payTip: "付费成为我的高级订阅",
    month: "/ 月",
    minPayTip: "最低付费金额为每月{amount}美元",
    disable: "禁用此功能",
    enable: "启用此功能",
    feeTip: "饼次元将从用户为您的伙伴支付的守护和高级订阅费用中抽取30%的佣金",
  },

  subscription: {
    name: "订阅",
    tips: "付费订阅您的人，将可以看到您角色相册中标记 高级订阅可见 的内容。",
    otherTips: "您可以通过付费订阅该角色以解锁角色相册中的高级订阅可见内容。",
  },

  settingsSaved: "已保存",
  settingsUnsaved: "保存中",
  scenarioSaved: "场景已保存",
  scenarioSaving: "场景保存中",
  gameDemoList: "游戏Demo列表",

  rewardCountDown: "{hours}小时{minutes}分{seconds}秒后可领取",

  rareEnergyBox: "罕见能量箱",
  rareEnergyBoxProgress: "领取5个能量箱 进度{count}/5",

  memberType: {
    [MemberType.Free]: "免费",
    [MemberType.Standard]: "行星构筑师",
    [MemberType.Premium]: "星系幻想家",
    [MemberType.Basic]: "小镇规划师",
  },
  forFree: {
    [MemberType.Basic]: "小镇规划师免费",
    [MemberType.Standard]: "行星构筑师免费",
    [MemberType.Premium]: "星系幻想家免费",
  },
  billingCycle: {
    [BillingCycle.Month]: "连续包月",
    [BillingCycle.Quarter]: "连续包季",
    [BillingCycle.Year]: "连续包年",
  },

  memberStatus: {
    active: "生效中",
    canceled: "已取消自动续费",
  },

  // 立即续费
  immediateRenewal: "立即续费",
};

const Buttons = {
  regenerate: "重新生成",
  insertAnimationVerticalDrawing: "插入动画立绘",
  insertPicture: "插入图片",
  locationReset: "位置重置",
  canvasReset: "画布重置",
  newFeature: "新建特征",
  nextTime: "下次再说",
  modifyNaming: "修改命名",
  createPortrait: "创作立绘",
  editPortrait: "编辑立绘",
  modifyPicture: "修改图片",
  placePicture: "置入图片",
  changeName: "改名",
  eraser: "橡皮擦",
  smear: "涂鸦",
  frameSelection: "框选",
  lasso: "套索",
  selectRedrawArea: "选择绘图区域",
  addPrompt: "添加提示词",
  startRedrawing: "开始",
  saveNewPortrait: "存为新立绘",
  coverOriginalImage: "覆盖原图",
  goToRepaintCanvas: "进入重绘画布",
  enterSmearCanvas: "进入涂抹画布",
  profile: "资料",
  importFromPublishedGames: "从已发布游戏导入",
  aiGenerateContentNode: "AI生成内容节点",
  contentNode: "内容节点",
  aiCompletion: "AI补全",
  ai: "AI补全",
  addDialogue: "添加对话",
  addNarration: "添加旁白",
  AIGenerateDialogueNode: "AI生成对话节点",
  jumpToSettings: "跳转设置",
  addReplyOption: "增加回复选项",
  clickToFillIn: "点击填写",
  editPlotDialogue: "编辑剧情对话",
  connectPlotPoint: "连接剧情点",
  chooseBackgroundMusic: "选择背景音乐",
  uploadMusic: "上传音乐",
  addEnding: "添加结局",
  editName: "编辑名称",
  editPlotPointOverviewDescription: "编辑剧情点描述概况",
  add: "添加",
  copyPlayLink: "复制游玩链接",
  viewHome: "查看主页",
  viewUserHome: "查看作者首页",
  startGame: "开始游戏",
  review: "回顾",
  continue: "继续",
  continueWriting: "继续写",
  switch: "换一换",
  undo: "撤销",
  writing: "AI写作",
  insert: "插入",
  selectAll: "全选",
  deselectAll: "取消全选",
  addMoment: "添加饼友圈",
  preview: "预览",
  listing: "上架",
  delisting: "下架",
  exitPreview: "退出预览",
  splitSettings: "分割设置",
  merge: "合并",
  chooseImage: "选择配图",
  quickGenerate: "快速生图",
  customGenerate: "自定义生图",
  replace: "替换",
  manualCreation: "手动创作",
  copy: "复制",
  copyText: "复制文本",
  autoGenerate: "自动生成",
  read: "阅读",
  clearSelection: "清空选择",
  done: "完成",
  newmate: "创作新伙伴",
  create: "创作",
  apply: "应用",
  batchApply: "批量应用",
  chatnow: "聊天",
  chat: "聊天",
  root: "创作",
  edit: "编辑",
  delete: "删除",
  publish: "发布",
  syncDataAndPreview: "同步数据并预览",
  editPersonalityPrompt: "修改人物设定",
  fork: "创作分支",
  save: "保存",
  back: "返回",
  stop: "停止",
  generateIntro: "生成人物介绍",
  isGenerateCoverIntro: "重新生成人物介绍",
  confirm: "确认",
  cancel: "取消",
  close: "关闭",
  reset: "重置",
  overview: "概述",
  genealogy: "迭代",
  markAsRead: "标记为已读",
  view: "查看",
  verify: "验证",
  createThread: "创作随记",
  myThread: "我的随记",
  createImage: "创作图片",
  createStory: "创作故事",
  createNewCharacter: "创作新角色",
  createPost: "创作饼友圈",
  skip: "跳过",
  newTask: "新建任务",
  agree: "同意",
  deny: "拒绝",
  update: "更新",
  createCustom: "创作自定义{name}",
  createAttribute: "创作属性",
  deleteModule: "删除模块",
  deleteCharacter: "删除角色",
  deleteWorldview: "删除星球",
  deleteAccount: "删除账户",
  uploadImage: "上传图片",
  uploadVideo: "上传视频",
  uploadAudio: "上传音频",
  new: "新建",
  select: "选择",
  unselect: "取消选择",
  selected: "已选择",
  addChatExample: "添加聊天样例",
  sure: "确定",
  upload: "上传",
  allAlbum: "全部稿件",
  createPublicChat: "创作公开对话",
  createPrivateChat: "新建聊天",
  collapse: "收起",
  expand: "展开",
  allReplies: "所有回复",
  createForTa: "为Ta创作",
  savedAlbum: "存入相册",
  generateImage: "预览",
  // 词库
  lexicon: "词库",
  editLexicon: "编辑词库",
  generateVideo: "生成视频",
  generate: "生成",
  tryListen: "试听",
  viewAll: "查看全部",
  deleteReferenceImage: "删除参考图",
  brush: "重绘",
  selectBackgroundImage: "选择背景图",
  changeBackgroundImage: "更换背景图",
  change: "更换",
  clear: "清空",
  selectCharacterImage: "选择人物图",
  all: "全部",
  recentChat: "最近的聊天",
  newChapter: "新建章节",
  nextChapter: "下一章",
  lastChapter: "已经是最后一章啦",
  previousChapter: "上一章",
  firstChapter: "已经是第一章啦",
  momentSave: "暂存",
  submit: "提交",

  createNewGame: "创作视觉小说",
  gamePlay: "游玩",
  insertEmoji: "插入表情",
  gameOnly: "仅发布游戏",
  momentUpdate: "同时更新饼友圈",

  switchCharacters: "切换角色",
  clearBg: "清空背景",
  clearCharacterAndAnimation: "清空立绘和动画",
  clearCanvas: "清空画布",

  loginToReply: "登录饼次元后回复",
  toDiscord: "反馈",

  shareToMoments: "分享到饼友圈",
  play: "播放",

  addImage: "添加图片",
  horizontalFlip: "水平翻转",
  lockOrUnlock: "锁定/解锁",

  bind: "绑定",
  withdrawSetting: "收款设置",
  importFromCharaCard: "从角色卡导入",

  exchange: "兑换",
  notSetTone: "不设置音色",

  superAdmireSuccess: "高级订阅中",
  loginToChat: "登录饼次元继续聊天",
  getApp: "获取应用",
  ok: "知道啦",

  next: "下一步",
  manage: "管理",
  get: "获取",
  startChat: "开始聊天",
  allTags: "全部标签",

  trending: "最近热门",
  popular: "最受欢迎",
  editorChoice: "编辑精选",
  setDefault: "设为默认",
  playScene: "开始",

  trial: "试用",
  enroll: "报名",
  createGame: "创作视觉小说",
  editProfile: "编辑设定",
  viewCharacterCard: "角色卡",
  story: "故事",
  writeDown: "随记",
  writeStory: "写故事",
  applyList: "申请列表",

  import: "导入",
  event: "事件",
  sort: "排序",
  swapSort: "交换排序",
  editContent: "编辑内容",
  editEvent: "编辑事件",

  createWorldview: "创作星球",

  relation: "关联",

  goTo: "前往",
  registerOrLogin: "注册&登录",
  createMate: "创建角色",
  handDraw: "随画",
  setting: "设定",
  paymentCompleted: "已完成支付",
  paymentCancelled: "放弃支付",
  reply: "回复",

  send: "发送",
  saveDraft: "保存草稿",
  publishOnly: "仅发布角色",
  publishAndEnterPool: "发布并放入互动池",
  voice: "语音",
  history: "历史记录",
  download: "下载",
  evaluate: "评估",
  forget: "遗忘",
  open: "打开",
  advanced: "进阶",
  enterHome: "进入伙伴的小屋",
  homeActivityLog: "小屋对话",
  treehole: "树洞",
  unlink: "解除关系",
  claim: "领取",
  viewMore: "查看更多",
  interactionLog: "互动日志",
  create1: "创建",
  yes: "是的",
  no: "不",
  copyGroupNumber: "复制群号",
  cancelRenewal: "取消订阅",
  resumeSubscription: "恢复订阅",
};

const Titles = {
  community: "社区",
  me: "我",
  mymates: "我的伙伴",
  displayLanguage: "展示语言",
  mateLanguage: "伙伴语言",
  chattextcolor: "对话文本颜色",
  createForTa: "为Ta创作",
  splitSettings: "分割设置",
  releaseGame: "发布游戏",
  previousConversation: "上一个对话",
  nextConversation: "下一个对话",
  unmute: "取消静音",
  mute: "静音",
  exitSceneMode: "退出场景模式",
  scene: "场景",
  trendingTags: "热门标签",
  resultCount: `共{count}个关于<span class="text-primary">"{keyword}"</span>的结果`,
  features: "常用功能",
  others: "其他功能",
  friends: "好友",
  inviteFriends: "邀请",
  relationship: "关系",

  // 能量箱
  energyBox: "能量箱",
  createOC: "创作一个OC",
  dreamHome: "伙伴小屋",
  sprite: "形象",
};
const Language = {
  mateSelect: "伙伴语言",
  chinese: "中文",
  english: "英文",
};
const Tabs = {
  hot: "热度",
  new: "时间",
  top: "排行",
  private: "未发布",
  draft: "草稿",
  published: "公开",
  latest: "最新",
  myCreations: "我创作的",
  recommend: "热门推荐",
};
const Newmates = {
  delete: "删除",
  draft: "草稿",
  name: "伙伴姓名",
  namePlaceholder: "请输入伙伴的姓名",
  namePrompt: "你的名字叫：",
  yourmateavatar: "伙伴的头像",
  chat: "聊天",
  gender: "性别",
  male: "男性",
  female: "女性",
  unisex: "中性",
  notSet: "不设置",
  crop: "剪裁",
  reset: "重置",
  coverintro: "伙伴介绍",
  coverinfo1: "以下内容将基于伙伴的描述自动生成",
  coverinfo2: "等待生成中",
  appearance: "外表",
  personality: "描述",
  tone: "音色",
  overview: "试用",
  avatargallery: "头像",
  suggested: "推荐",
  uploaded: "已上传",
  upload: "上传",
  personalityprompt: "人物设定",
  personalitypromptHistory: "修改历史",

  describe: `为了让我扮演一个人物，你需要提供一个明确且具体的描述，这样我才能更好地理解你的要求并根据你的设定进行回应。以下是编写一个好的提示的建议：

明确角色：在提示中明确说明你希望我扮演的角色，例如某个历史人物、虚构角色或专业人士。

提供背景信息：为角色提供一些背景信息，如个性特征、重要经历、家庭背景等，这有助于我更好地理解这个角色的特点和行为。

设定情境：描述一个具体的场景或问题，让我知道在什么情境下进行回应。这可以包括地点、时间以及与其他角色的互动等。

提问或指导：用一个问题或者具体的指导来引导我进行回答或者表现。这可以是一个开放式问题、建议或者具体的任务。

限定回答风格：如果需要，可以在提示中指定回答的风格，例如正式、幽默或充满激情等。`,
  autocomplete: "自动补全",
  save: "保存",
  suggestedprompt: "人物设定提示",
  enterdialogue: "选择好音色、输入文字后，可点击播放按钮预览音色",
  currenttone: "已选择音色：",
  play: "播放",
  tonegallery: "可选音色",
  select: "选择",
  selected: "已选择",
  untitled: "待命名的伙伴",
};
const Chats = {
  chooseChat: "选择聊天",
  basicSettings: "基本设置",
  modelTip: "选择聊天使用的语言模型，这决定了对话的风格和费率",
  name: "聊天会话名称",
  nameTip: "展示在聊天会话列表中的名称",
  thumbnail: "缩略图",
  chatMode: "聊天模式",
  audio: "音频",
  audioAutoPlay: "消息语音自动播放",
  deleteCurrentChat: "删除当前聊天",
  publishedAt: "发布于：",
  published: "已发布",
  unpublished: "未发布",
  append: "补充",
  appendPrompt: "补充人物设定",
  chat: "聊天",
  cast: "演员",
  currentChat: "当前聊天",
  empty: "没有消息",
  generate: "根据 prompt 生成",
  style: "风格",
  scene: "场景描述",
  selectSceneImage: "选择场景图片",
  saysomething: "你想对我说些什么？ (⌘ + ↩ 或 ⌃ + ↩ 换行)",
  send: "发送",
  typing: "正在打字中...",
  summary: "前情概要",
  master: "主人",
  scenePlaceholder:
    "输入场景描述信息，可让读者的沉浸感更强 (⌘ + ↩ 或 ⌃ + ↩ 换行)",
  sceneDescription: "场景描述",
  sceneHelp: "描述背景，让读者更身临其境",
  selectAll: "选择全部",
  showMore: "显示更多",
  publishMate: "发布伙伴",
  tellAboutMate: "向其他人介绍一下这个伙伴",
  tellAboutMateExample:
    "例如：这是名为 Yae Miko 的日本女教师，有人能约他出去喝酒吗？",
  says: "对",
  to: "说",

  all: "所有人",
  actors: "演员",
  toMate: "伙伴",
  toActors: "演员",

  newCast: "新演员",
  noCasts: "没有演员",

  chooseCharacterToChat:
    "选择一个和&nbsp;<spna class='text-primary'>{name}</spna>&nbsp;聊天的角色",

  createChat: "你正在准备与",
  createChatHalf:
    "建立对话，公开对话会被Ta背后的神秘主人看到。如果你不想让你们的对话被看到，请使用私密对话",

  initiateChat: "如何建立对话？",
  publicChat: "公开对话",
  publicOne: "可以交流现实世界",
  publicTwo: "回复可能不及时",
  publicThree: "背后的神秘力量会看到",

  privateChat: "私密对话",
  privateOne: "私密对话不会被看到",
  privateTwo: "回复很及时",
  privateThree: "可展开多组对话",

  waitingTips: {
    0: "正在布置环境",
    1: "正在为角色化妆",
    2: "正在为角色挑选衣服",
    3: "正在为角色挑选发型",
    4: "正在为角色安排行程",
    5: "正在摸鱼",
    6: "怎么还没加载完，编不下去了",
    7: "好吧，再等一会，马上就准备好啦",
  },
  noInitiatedPublicChat: "还没有开启公开对话",
  noInitiatedPrivateChat: "还没有开始的聊天",

  proxyEnabled: "代理回复已启用",
  proxyDisabled: "正在关闭代理回复",
  proxyEnabling: "正在开启代理回复",
  sendMsgTo: "发送消息给 {name}",
  voiceAutoPlay: "已启用语音自动播放",
  publicHelpHalf: "你正在与",
  publicHelpTwo:
    "进行公开对话，该对话会被Ta背后的神秘力量看到，禁止使用黄色、暴力、反动等语言",
  privateHelpHalf: "你正在与",
  privateHelpTwo: "进行私密对话，对话内容只对你可见",
  connecting: "连接中...",

  invalidExt: "角色卡仅支持png,json格式",
  noPngMetaData: "当前图片中未包含角色数据",
  failToParseCard: "角色卡解析失败，请检查文件是否正确",
  enablingLoverMode: "正在启用恋人模式",
  disablingLoverMode: "正在关闭恋人模式",
  unlockEntireMsg: "解锁完整消息",
  autoUnlock: "自动解锁",
  mateHome: "角色主页",
  messageTypeLabel: "输入",
  replyTypeLabel: "回复",
  messageType: {
    message: "消息",
    text: "描写",
    instruction: "命令",
    inputIntro: "输入用于标记您输入的内容，来提升模型的回复表现",
    messageIntro:
      "消息是来自您自己的一段对话。它可能直接包含对话内容，但也包含一些对角色行为或想法的描述。",
    textIntro:
      "描述是角色扮演故事的简单部分，不属于任何角色。常用于描述场景、提供背景等。",
  },
  replyType: {
    text: "回复描写内容",
    replyIntro:
      "回复用于您控制模型的返回的内容，让您更好的推进和控制故事的进展",
    random: "默认",
    replyBy: "由角色回复",
    textIntro:
      "描述是角色扮演故事的简单部分，不属于任何角色。常用于描述场景、提供背景等。",
    replyByIntro:
      "控制模型扮演角色并回复一段对话。它可能直接包含对话内容，但也包含一些对角色行为或想法的描述。",
    randomIntro: "完全由模型决定接下来的回复内容",
  },
  continue: "继续",
  selectChatOnTheLeft: "在左侧角色选择一个开始聊天",
  selectModel: "选择模型",
  tokenLimit: "上下文长度",
  perMessage: "每条消息",
  supportLanguage: "支持语言",
  lang: {
    all: "所有",
    en: "英文",
  },
  censored: "受限",
  uncensored: "不受限",
  chatSessions: "聊天会话",
  recentPost: "最近饼友圈",
  mateEmotion: {
    intro:
      "表情图片是随机在AI聊天中返回的图片。AI会根据'表情名称'与图片的描述信息计算关联性，若存在关联的图片，则会随文本一起回复。",
    name: "表情名称",
    nameTip:
      "在聊天中，AI将根据您输入的表情名称与聊天内容进行匹配，并将相应的表情图片展示在聊天背景中",
    editTip: "在确认添加/更新后，您的表情更新内容将立刻生效。",
    emptyTitle: "暂无表情",
    emptyDesc: "请点击右上角按钮添加表情",
    addDefault: "自动添加默认表情",
  },
  chatImage: {
    intro:
      "自拍是指角色在用户请求自拍时发送给用户的图片。该按钮位于聊天输入框的 - “加号”图标中的“给我发张照片”按钮。",
    price: "价格",
    priceTip:
      "自拍的价格，设置后用户在聊天中需要支付解锁才能查看图片，最低价格为0.5水晶",
    priceNotSetTip: "最低价格为0.5水晶",
    editTip:
      "在确认添加/更新后，您的自拍更新内容将立刻生效, 在已经开始的聊天中AI将立即随机发送您上传的聊天图片给与您的角色进行聊天的用户",
    emptyTitle: "暂无自拍",
    emptyDesc: "请点击右上角按钮添加自拍",
    free: "免费",
  },
  advancedOption: "高级选项",
  chatScene: {
    name: "场景",
    tip: "情境描述了与角色互动时的环境、情况或背景，提供了影响对话的重要背景信息。",
    isCommon: "这是一个通用场景？",
    isCommonTip:
      "通用场景和角色没有很强的关联性，可以在任何聊天中使用，并且往往通过{'{{char}}'}和{'{{user}}'}占位符来替换角色和用户的名称",
    emptyTitle: "暂无场景",
    emptyDesc: "请点击右上角按钮添加场景",
    specific: "角色限定",
    generic: "通用",
    edit: {
      basic: "基本",
      desc: "描述",
      descTip:
        "场景描述包含与角色互动时发生的环境、情境或背景，并提供影响对话的重要背景信息。",
      firstMsg: "第一条消息",
      firstMsgTip:
        "第一条消息是 AI 角色在开始新聊天时发送的初始文本。它应介绍角色并为互动奠定基础，反映角色的个性和情境。",
      systemPrompt: "系统",
      systemPromptTip:
        "系统提示是一个可选组件，提供给 AI 模型额外的上下文和指示，帮助更具体地引导 AI 的行为和回应。",
      shortDesc: "简介",
      shortDescPlaceholder: "场景简介，仅用于展示",
      shortDefinition: "简短定义",
      shortDefinitionPlaceholder:
        "AI 如何确定数值的增加或减少，以及增加或减少的幅度。",
      coverImage: "封面图片",
      coverImageTip: "推荐上传GIF动图",
      roundsLimit: "回合限制",
      roundsLimitPlaceholder: "到达回合后，聊天结束",
      name: "名称",
      namePlaceholder: "场景名称",
      target: "目标",
      targetDesc: "随着游戏进展，哪些数值会随着玩家进展而变化",
      targetNamePlaceholder: "目标名称",
      type: "类型",
      default: "默认",
      condition: "条件",
      reaction: "反应",
      winning: "胜利",
      losing: "失败",
      endingScript: "结束脚本",
      add: "添加",
      preview: "预览",
      from: "从",
      to: "到",
      delete: "删除",
      save: "保存",
      targetNameInfo:
        "目标名称，将作为聊天中显示的名称，而且是作为AI驱动的重要依据，请尽量使用清晰且简洁的名称。如果删除目标名称，则将会移除该目标",
      eventNameInfo:
        "事件名称，将作为聊天中显示的名称，而且是作为AI驱动的重要依据，请尽量使用清晰且简洁的名称。",
      numericalNamePlaceholder: "数值名称",
      numericalNameInfo:
        "数值名称，将作为聊天中显示的名称，而且是作为AI驱动的重要依据，请尽量使用清晰且简洁的名称。如果删除数值名称，则将会移除该数值",
      generate: "生成",
      reactionTips: "生成反应的关键词",
      overwrite: "覆盖",

      event: "事件",
      eventPlaceholder: "事件名称",
      eventDesc: "游戏进行中随机发生的事件，可以增加玩家体验的不确定性",
      probability: "概率",
      definition: "定义",

      character: "角色",
      characterDesc: "在场景中出现的角色",
      characterSelect: "选择角色",

      // 数值相关
      numerical: "数值",
      numericalSelect: "选择数值",
      applyCharacter: "应用角色",
      noTarget: "当前角色没有目标，玩家将无法扮演该角色进行游戏",
      winTarget: "胜利目标",
      failReason: "失败原因",
      attr: "属性",
      value: "值",

      relatedEvent: "相关事件",

      deleteCharacterTips:
        "删除角色后，数值中绑定的角色将自动移除，以及与角色相关的目标也会被自动移除，确认删除吗？",
      deleteEventTips:
        "删除事件后，数值定义中绑定的所有事件将自动移除，确认删除吗？",

      deleteScore:
        "删除数值后，数值定义中绑定的所有数值提示词已经绑定的事件将自动移除（不会移除事件，只会将绑定关系移除），确认删除吗？",
      scoreType1: "状态",
      scoreType2: "属性",
      noTarget2: "当前角色没有目标",
      noScore: "当前角色没有数值",
      yourTurn: "你的回合",

      // 位置相关
      position: "位置",
      positionNamePlaceholder: "位置名称",
      currentPosition: "当前位置",
      shortDescription: "简短描述",
      shortDescriptionPlaceholder: "当前位置的简短描述",
      enterCondition: "进入条件",
      enterConditionPlaceholder: "AI 判定角色是否可以进入场景的条件。",
      leavingCondition: "离开条件",
      leavingConditionPlaceholder: "AI 判定角色是否可以离开场景的条件。",
      connectLocation: "可抵达的其他位置",
      containCharacter: "出现的角色",
      noOtherPosition: "当前位置没有其他可抵达的位置，请先添加一个位置",
      childrenPosition: "子位置",
      selectDestination: "选择可抵达的位置",
      pleaseAddCharacter: "暂时没有角色可选择，请先添加角色",

      deleteParentPositionConfirm:
        "删除父位置后，子位置将全部自动移除，确认删除吗？",
      deleteParentCharacterConfirm:
        "删除父位置的角色后，子位置中添加的角色将全部自动移除，确认删除吗？",
      deleteParentDestinationConfirm:
        "删除父位置的可抵达位置后，子位置中添加的相关可抵达位置将全部自动移除，确认删除吗？",
      pleaseAddNameFirst: "请先添加名称",
      notInSamePosition: "角色与玩家不在同一位置",
      positionDescPlaceholder: "位置的简短描述，",
      accessibleDefinition: "可达性定义",
    },
  },
  matePersona: {
    tip: "关系可以作为可选择的角色提示词的扩展，将设定和系统提示词追加到角色设置中的提示词之后，用于增强角色的行为和聊天风格。",
    name: "名称",
    description: "描述",
    nameTip: "关系的名称，仅用于展示",
    descriptionTip: "关系的描述，仅用于展示",
    emptyTitle: "暂无关系",
    emptyDesc: "请点击右上角按钮添加关系",
    default: "默认人格",
  },
  noPicForYouNow: "暂时没有要发给你的照片",
  thinking: "正在生成回复...",
  generateError: "生成失败, 点击进行重试",
  noPicAvailable: "这个角色还没可以发送的照片",
  picExhausted: "这个角色的所有照片已经发完了",
  sendMePhoto: "给我发张照片",
  noPhoto: "无照片",
  translateLanguage: "翻译语言",
  assistantFeature: "助手功能",

  enteringOptionMode: "正在进入选项模式...",
  selectMateTone: "选择角色音色",
  selectNarratorTone: "选择旁白音色",

  maleVoice: "男声",
  femaleVoice: "女声",
  targetWin: "你赢得了这局游戏",
  targetLose: "你输掉了这局游戏",
  targetReach: "{targetName} 达到了 {targetScore}",
  pickNewMate: "与新角色聊天",
  restartGame: "重新开始游戏",
  game: "视觉小说",
  success: "成功",
  failed: "失败",
  timeFastForward: "时间快进",
  timeFastForwardTip: "快进故事时间以推进剧情",
  fastForwardOneDay: "一天",
  fastForwardOneWeek: "一周",
  fastForwardOneMinute: "一分钟",
  fastForwardOneHour: "一小时",
  actions: {
    say: "说",
    do: "做",
    sneak: "潜行",
    move: "移动",
    fight: "战斗",
    items: "物品",
    mixed: "混合",
  },
  confirmAction: "确认尝试{action}到{name}吗？",
  confirmFight: "确认尝试攻击{name}吗？",
  temperature: {
    title: "随机性",
    low: "死板的",
    high: "有创造力的",
    tip: "影响角色的反应，数值越高，角色越有可能做出出人意料的回答，数值越低，角色越有可能按照剧本回答。",
  },
  chooseReplier: "选择回复者",
};

const ChatCast = {
  avatar: "演员头像",
  intro: "介绍",
  name: "姓名",
  newCast: "新演员",
  noCasts: "没有演员",
  position: "职位",
  relation: "关系",
};

const loginmodal = {
  cancel: "取消",
  login: "登录",
  hasAccount: "已有账号登录",
  email: "邮箱地址",
  googleLoginInfo: "通过Google账户登录",
  signInWithApple: "通过Apple账户登录",
  emailplaceholderCorrectly: "请正确输入您的电子邮件地址",
  emailplaceholder: "请输入您的电子邮件地址",
  continuewithemail: "发送电子邮件验证码",
  text: "通过点击上面谷歌/电子邮件/电话继续，您确认已阅读并理解并同意任何伙伴的条款和隐私及隐私政策",
  sendcode: "发送验证码",
  verifyCodeSentSuccess: "验证码已发送",
  invalidCode: "验证码无效",
  resend: "重新发送",
  resendHit: "",
  resendHit2: "秒后可重新发送",
  verificationcode: "验证码",
  inputVerificationCode: "请输入验证码",
  staticCode: "静态密码",
  viewFollowUp: "登录后查看关注饼友圈",
  viewLoggingIn: "登录后查看你关注的人的饼友圈",
  continue: "继续",
  prevStep: "上一步",
  nextStep: "下一步",
  register: "新用户注册",
  male: "男",
  female: "女",
  createYourCharacter: "创作你的角色",
  setAvatar: "创作二次元头像",
  characterAppearance: "角色形象",
  selectPhoto: "选择照片",
  randomGenerate: "随机生成",
  selectStyle: "选择风格",
  confirmAndGenerate: "确定并生成",
  regenerate: "重新生成",
  characterName: "角色姓名",
  enterName: "请输入姓名",
  enterEmail: "请输入您的邮箱地址",
  theLastStep: "最后一步",
  welcome: "欢迎来到饼次元",
  enterCommunity: "加入社区",
  downloadImage: "下载图片",
  skip: "跳过",
  generating: "生成中，请不要刷新页面...",
  receiving: "接收中，请不要刷新页面...",
  avatarClickTipTitle: "就快完成啦",
  avatarClickTip: "完成注册后，即可下载高清头像！",
  downloadAvatarTip: "点击'下载图片按钮'后，长按图片保存到相册",
  notSetGender: "不设置性别",
  setYourRole: "您在聊天中的角色",
  prepare: "准备",
  phone: "手机号码",
  phoneplaceholder: "请输入您的手机号码",
  phoneplaceholderCorrectly: "请正确输入您的手机号码",

  switchToEmail: "切换到邮箱",
  switchToPhone: "切换到手机",

  currentVersion: "当前版本",

  loginAgreement: "登录即表示您已阅读并同意",
  registerAgreement: "注册即表示您已阅读并同意",
  userAgreement: "《用户协议》",
  privacyPolicy: "《隐私政策》",
  and: "和",
  inviteCode: "邀请码",
  inviteCodePlaceholder: "(可选) 请输入邀请码",
  switchToLogin: "已有账号，去登录",
  switchToRegister: "没有账号，去注册",

  pleaseAgree: "请阅读并同意以下条款",

  agreeAndContinue: "同意并继续",
};
const card = {
  try: "免费试用",
  discuss: "讨论:",
  fork: "分支:",
};
const Texts = {
  notLike: "不喜欢",
  like: "喜欢",
  backHome: "回到首页",
  node: "节点",
  beenReachedEn: "已达到结局",
  stillNothingTheAlbum: "相册中还什么都没有",
  displayText: "显示文本",
  enterName: "请输入名称",
  chooseStory: "选择故事",
  selectChapter: "选择章节",
  whenChapterPublishedYourFeed: "当章节发布后会出现在你的饼友圈中",
  whenVisualNovelPublishedYourFeed: "将视觉小说分享到饼友圈",
  whenVideoPublishedYourFeed: "将视频分享到饼友圈",
  chapterPublishedNotModify: "当章节发布后将无法修改",
  contentChapter: "和大家介绍一下本章内容吧",
  contentChapterPlaceholder: "这里填写的内容会作为饼友圈的正文与章节一起发布",
  chatRecord: "聊天记录",
  textMode: "文字模式",
  sceneMode: "场景模式",
  characterSettings: "角色设置",
  characterPortrait: "特征立绘",
  verticalPainting: "立绘",
  introRoleplayAnswer: "和大家介绍一下这个回答吧",
  animation: "动画",
  canvas: "画布",
  zoom: "缩放",
  coordinate: "坐标",
  redrawWidth: "重绘幅度",
  portraitName: "立绘名称",
  newVerticalPaintingName: "新立绘名称",
  redrawPromptWord: "重绘提示词",
  pleaseEnterPromptWord: "请输入提示词(仅支持英文，以英文逗号分隔)...",
  redrawBasedTh: "基于第{index}张图片重绘",
  cloneSelectedNodeBelow: "克隆到选择节点的下方",
  lastedit: "上次编辑时间:",
  fordToEdit: "当您创作分支后即可与Mate进行对话",
  afterSentences: "{amount} 句话之后",
  notModified: "无法修改当前聊天。",
  mateIntroDesc:
    "以上内容为人物介绍，用于向其他用户展示。不会对人物设定产生影响。点击文字区域可编辑。",
  noIntroductionText: "这家伙没有留下任何介绍",
  characterImage: "人物图",
  clickUpperRight: "点击右上角按钮添加图片",
  allComments: "全部评论",
  submittedCreationForTa:
    "将会收到你提交的创作，在通过后创作会发布到Ta的饼友圈中",
  submittedCreationPlaceholder:
    "在这里告诉{mateName}你的想法吧，这会帮助Ta更快的完成审核",
  splitSettingText:
    "分割设置，会将整个文章的每一个段落按照分隔符号进行分割，分割后的每一段中间都可以插入配图。",
  afterCompletingFromText: "其他内容，完成填写后可以选择参考",
  completeContent: "请在这里补全内容",
  saveTime: "保存时间",
  gamePublished: "当游戏发布后会出现在你的饼友圈中",
  gamePublishedNotModified: "游戏发布后将无法修改",
  introGame: "和大家介绍一下游戏内容吧",
  introCollection: "和大家介绍一下合集内容吧",
  gamePublishedPlaceholder: "这里填写的内容会作为饼友圈的正文与游戏一起发布",
  sharePlaceholder: "这里填写的内容会作为饼友圈的正文与分享内容一起发布",

  estimatedRemainingTime: "预计剩余时间",
  createAt: "创作时间",
  promptText: "提示词",
};

const Message = {
  filterAiContentTip: "若你不想看到AI内容，可在我的-设置-内容设置中打开过滤AI",
  addingPleaseTryAgainLater: "添加中，请稍后重试",
  chooseConversation: "选择对话",
  regeneratingAudio: "正在重新生成音频",
  regeneratedAudioSuccessfully: "重新生成音频成功",
  regeneratedAudioFailed: "重新生成音频失败",
  inCutting: "正在裁剪中...",
  creatingStoryIllustrationTask: "正在创作故事配图任务",
  parsingThePicture: "正在解析图片",
  overlaySuccess: "操作成功",
  overwritingOriginalFeature: "正在覆盖原特征...",
  generatingFeature: "正在生成特征...",
  creatingFeature: "正在生成特征...",
  pleaseEnterFeatureName: "请输入特征名称",
  newTaskBeenCreated: "已创作新任务",
  taskCompletedPleaseCheckToMarked: "该任务已完成，请到待标记查看",
  checkingTheTask: "正在检查任务",
  cancelSuccessfully: "取消成功",
  cancellingMission: "正在取消任务",
  needFeatures: "使用绘画功能前您需要创作人物特征",
  changingCover: "正字更换封面",
  creatingDynamicPictureTask: "正在创作饼友圈图片任务",
  enterAnimationName: "请输入动画名称",
  createAStoryFirst: "请先创作一个故事",
  noStory: "暂无可用的故事",
  selectAddToStory: "选择要添加到的故事",
  chapterIntoStory: "正在将章节塞进故事...",
  storyModifiedSuccessfully: "故事修改成功",
  storyCreatedSuccessfully: "故事创作成功",
  enterStoryName: "请输入故事名称",
  enterStoryDesc: "请输入故事描述",
  selectStoryCover: "请选择故事封面",
  textGeneratedToast:
    "文风案例是指您想要生成的故事的文笔风格，建议填写文风案例，使生成内容的风格更加稳定。",
  chapterPublishedSuccessfully: "章节发布成功",
  releasingChapterUniverse: "正在向宇宙发布章节...",
  autoSaveFailed: "自动保存失败",
  chapterCopying: "正在将章节送到宇宙档案管复印...",
  chapterCopiedSuccessfully: "章节复制成功",
  soundPlaybackError: "声音播放出错啦",
  processingImage: "正在处理图片...",
  newsSeemsMissing: "消息好像不见了",
  dynamicDisappearedInto: "这个饼友圈消失在宇宙中了",
  wordCountLimited: "字数不能超过{number}哦",
  settingScene: "正在设置场景",
  cancelAutomaticPlay: "取消语音自动播放",
  automationPlay: "语音自动播放",
  enablingAudioPlay: "正在启用语音自动播放",
  closingAudioPlay: "正在关闭语音自动播放",
  enabledSuccessfully: "启用成功",
  closedSuccessfully: "关闭成功",
  exitingSceneMode: "正在退出场景模式",
  unlockScenes: "解锁场景",
  lockScenes: "锁定场景",
  onceUnlocked: "解锁后，场景将会随着对话的进行而变化",
  onceLocked: "锁定后，场景将不会随着对话的进行而变化",
  reachedBeginningTime: "已经到时间线的开端啦",
  viewMorePreviousConversations: "正在查阅更多之前的对话",
  currentMaxTen: "目前最多允许选择10个",
  partnerPublishedSuccessfully: "您的伙伴已经发布成功",
  apiKeyCannotEmpty: "apiKey 不能为空",
  forkSuccessful: "FORK成功",
  nodeCloning: "节点克隆中...",
  nodeCloneSuccessfully: "节点克隆成功",
  cloningFailed: "克隆失败，请重试",
  addingRetry: "添加中，请稍后重试",
  addThisRoleFirst: "请先添加该角色",
  conversationAdditionFailed: "对话添加失败",
  updatedSuccessfully: "更新成功",
  createdSuccessfully: "创作成功",
  resetting: "正在重置...",
  whetherResetThisContent: "是否重置该项内容？",
  alreadyLatestVersion: "已是最新版本",
  newVersionDetected: "检测到新版本",
  updatedToTheLatestVersion: "已更新至最新版本",
  someMoreContentUpload: "还有一些内容正在上传中，请稍等一下",
  someContentUploadFailed: "有一些内容上传失败，请删除或重试",
  recap: "前景回顾",
  enterChapterName: "请输入章节名称",
  enterChapterDescription: "请输入章节描述",
  selectChapterCover: "请选择章节封面",
  creatingChapter: "正在创作章节...",
  savingChapter: "正在保存章节...",
  creatingStory: "正在创作故事...",
  savingStory: "正在保存故事...",
  chapterModifiedSuccessfully: "章节修改成功",
  chapterCreatedSuccessfully: "章节创作成功",
  updatingFeature: "正在更新特征...",
  failedUpdateFeature: "更新特征失败",
  deleteFeature: "删除特征",
  lastFeatureNotDeleted: "已经是最后一个特征啦，不能删除啦",
  sureRemoveFeature: "确认删除该特征吗？",
  deletingFeature: "正在删除特征...",
  cloningFeature: "正在克隆特征...",
  failedDeleteFeature: "删除特征失败",
  featureCloningFailed: "克隆特征失败",
  confirmCloneTrait: "确认克隆当前特征吗?",
  fetchingCharacterPortraitList: "正在获取立绘列表",
  removingCharacterPortraitBackground: "正在移除立绘背景",
  unnamedCharacterPortrait: "未命名立绘",
  savingCharacterPortrait: "正在保存立绘",
  failedDeleteCharacterPortrait: "删除立绘失败",
  deleteCharacterPortrait: "删除立绘",
  delete: "删除",
  redrawing: "正在重绘...",
  covering: "正在覆盖...",
  coverageSuccessful: "覆盖成功",
  updatingVerticalPainting: "正在更新立绘",
  failedToUpdateVerticalPainting: "更新立绘失败",
  creatingVerticalPainting: "正在创作立绘",
  exitRedrawnImage: "退出会清除未保存的重绘图片，确认退出吗？",
  deletingCharacterPortrait: "正在删除立绘",
  confirmDeletion: "确认删除 {name} 吗？",
  deleteConfirm: "确认删除吗？",
  noPromptText: "无提示词",
  taskAdded: "任务已添加",
  progress: "操作中...",
  addingCharacter: "正在添加角色",
  pleaseAddCharacterFirst: "请先添加角色",
  AIGenerating: "AI生成中...",
  AIGenerate: "AI生成",
  pullRefresh: "下拉刷新",
  releaseRefresh: "释放刷新",
  clickSelectCharacter: "点击选择角色",
  nothingWasWritten: "好像什么都没有写哦",
  choosePeopleRemind: "选择提醒的人",
  successfully: "修改成功",
  promptcopied: "已复制",
  promptsaved: "已保存",
  saved: "保存成功",
  likeTone: "标记为喜欢",
  createMate: "创作伙伴",
  beforeCreate: ` 在你的伙伴被创作后，它的外表和音色将不可修改。您确定要现在创作它吗?`,
  beforePublish: `在你的Mate发布后，你和Mate的聊天内容将会被所有用户看到，并且你与Mate的聊天记录将不能修改，你确定要现在发布吗？`,
  publishing: "正在发布中...请稍后",
  savingProgress: "暂存中...",
  sure: "确定",
  cancel: "取消",
  saving: "保存中...",
  storySaving: "正在保存故事...",
  saveSuccess: "保存成功",
  saveFailed: "保存失败",
  publishSuccess: "发布成功",
  shareSuccess: "分享成功",
  publishFailed: "发布失败",
  flippingThroughStoryBook: "正在翻故事书...",
  storyNoCreate:
    "你还有没有创作故事集，我们会根据你日常发布的状态为你创作一个故事集",
  snacksDuringChatPreparation: "正在准备聊天时的小零食",
  noMoreAvailable: "没有更多了",
  requestFailedClickToReload: "请求失败，点击重新加载",
  loading: "加载中...",
  unlocking: "正在解锁...",
  unlockSuccess: "恭喜🎉 解锁成功啦！",
  noContentAvailable: "暂无内容",
  noCharactersAvailable: "暂无角色",
  noTraitsAvailable: "暂无特征",
  noMateAvailable: "暂无Mate",
  noGame: "暂无游戏",
  noMateChangeKeywrod: "没有找到Mate, 换一个关键词吧",
  noMatchingRole: "没有找到角色, 换一个关键词吧",
  currentCreateStory: "当前角色还没有为故事创作章节",
  thisChapterNoContent: "当前章节没有内容",
  noPendingReviews: "还没有待处理的审阅",
  noCompletedReviews: "还没有已完成的审阅",
  noCreationsPendingReview: "还没有待审核的创作",
  noCompletedCreationsYet: "还没有已完成的创作",
  noAnimation: "还没有已经创作的动画",
  approved: "已通过",
  rejected: "已拒绝",
  allNow: "就这么多啦",
  unknown: "未知",
  notBio: "这个人没有留下任何简介",
  noGreetingIntro: "暂无场景介绍",
  deletingCharacter: "正在删除角色",
  deletingAttribute: "正在删除属性",
  failDeleteAttribute: "删除属性失败",
  creatingModule: "正在创作模块",
  failCreateModule: "创作模块失败",
  deletingModule: "正在删除模块",
  failDeleteModule: "删除模块失败",
  characterNameRequired: "需要填写角色名字才能发布哦",
  creatingAttribute: "正在创作属性",
  failCreatingAttribute: "创作属性失败",
  uploading: "上传中...",
  uploadSuccessful: "上传成功",
  uploadFailed: "上传失败",
  noStoriesYet: "暂无故事",
  noStoriesYetDesc: "当前角色还没有创作故事",
  noStoriesPublishedYet: "暂无发布的故事",
  noStoriesPublishedYetDesc: "当前角色还没有发布的故事",
  noGamesYet: "暂无游戏",
  noGamesYetDesc: "当前角色还没有创作游戏",
  settingChatEnvironment: "正在布置聊天环境",
  deletingPrivateChat: "正在删除私密对话",
  sureExit: "确认退出吗？",
  operationFailed: "操作失败了哦",
  applicationSentSuccessfully: "守护申请发送成功",
  fetchTraitList: "正在获取特征列表",
  generatingPromptWords: "正在生成提示词...",
  characterAlbum: "正在保存到角色相册...",
  savedAlbum: "已存入相册",
  creatingVideoTask: "正在创作视频任务",
  creatingStorySceneTask: "正在生成视觉小说",
  preparingImage: "正在准备为图片注入灵魂",
  savingAlbum: "正在保存到相册...",
  savingDialog: "正在保存到对话背景...",
  creatingImageGenerationTask: "正在创作图片生成任务...",
  creationSuccessful: "创作成功",
  preparingToCreateCharacter: "准备创作OC",
  switchingCharacters: "正在切换角色",
  loadingCharacter: "加载角色...",

  inOperation: "正在操作中...",
  noChatTitle: "暂无聊天信息",
  noChatDesc: "还没有保留的聊天信息",
  noChatHistoryYet: "暂无聊天记录",
  noChatHistoryYetDesc: "这里没有聊天记录可以分享哦",
  selectShareChat: "选择分享的聊天记录",
  deleting: "正在删除...",
  modifying: "正在修改",
  deleteSuccessful: "删除成功",
  switchingChatMode: "正在切换聊天模式",
  switchSuccessful: "切换成功",
  deletingStory: "正在删除故事...",

  noMomentsYet: "暂无饼友圈",
  storyNoMoment: "当前故事还没有关联的饼友圈",

  theCurrentChapter: "当前章节还没有关联的饼友圈",
  deletingChapter: "正在删除章节...",
  deleteChapterSuccessful: "章节删除成功",

  generatingLongImage: "正在生成长图...",
  longPressSaveImage: "长按保存到相册",
  rightClickImage: "右键另存为保存",

  selectMoment: "选择饼友圈",
  keywordEnterSerach: "输入关键词，按回车搜索",
  searchEnter: "搜索角色/饼友圈，回车键搜索",
  searchPlaceholder: "搜索饼次元中的内容",
  searchMateEnter: "搜索角色/作品，回车键搜索",
  hotCharater: "热门角色",
  chatWithHotCharacter: "与热门角色聊天",
  moreCharacters: "更多角色",
  featuredCharacter: "富有特色的角色",
  featuredScenario: "富有特色的场景",
  replace: "换一批",
  search: "搜索",
  inputKeywordsToSearch: "请输入关键词进行搜索",
  notRelatedMomentFound: "没有找到相关饼友圈",

  noWelcomeMoment: "暂无欢迎推荐",
  noRecommendedRoles: "还没有推荐的角色",
  pleaseEnterVerificationCode: "请输入完整的验证码",
  incorrectVerificationCode: "验证码错误",
  oh: "哦！",
  connectionFaild: "哦！和宇宙链接失败了",

  displayName: "展示名称",
  enterDisplayName: "请输入展示名称",
  englishPrompt: "英语提示词",
  enterEnglishPrompt: "请输入英文提示词",
  submissionSuccessful: "提交成功",
  submissionFailed: "哦！提交失败了",

  completeChapterBeginning: "请先完成章节开头",
  completeChapterEnding: "请先完成章节结尾",

  loadingStory: "正在加载故事...",
  otherVersion: "其他的版本",
  nothingWritten: "好像什么也没写出来",
  creating: "创作中...",

  copySuccessful: "复制成功",
  removingRole: "移除角色中...",
  noDialoguesAvailable: "暂无对话",
  noTxAvailable: "暂无收益",
  pleaseSelectDialogText: "请选择跳转的对话或添加更多的对话",
  pleaseSelectContentNode: "请选择内容节点",

  noSelectableNodeAvailable: "没有可选的节点",
  pleaseEnterAudioName: "请输入音频名称",
  untitledMusic: "未命名音乐",
  notWrittenIntro: "介绍还没有写哦",
  publishingGame: "正在向宇宙发布游戏...",
  publishingShare: "正在向宇宙发布分享...",
  importing: "导入中...",
  importingSuccess: "导入成功",

  updateLogNotBeenFilledYet: "更新日志还没填哦",
  updateLogVersionError: "版本号比之前小",
  reachedEnd: "到底啦~",
  promptNotBeenFilledYet: "提示词还没填哦",
  sourceNotBeenFilledYet: "参考图还没上传哦",

  notLogin: "您还没有登录",
  checkingTicket: "正在检票...",
  checkingUpdate: "正在检查更新...",
  updating: "正在更新...",
  noUpdate: "已经是最新版本",
  switchingLanguage: "正在切换语言...",
  storyContentCanNotEmpty: "故事内容不能为空",

  paymentSuccessful: "支付成功",
  paymentCancelled: "支付取消",
  // 跳转支付中...
  paymentRedirecting: "跳转支付中...",

  editTrait: "是否前往编辑特征？",
  editTraitConfirm: "前往编辑特征页面会丢失当前编辑的内容，确认前往编辑吗？",
  createTrait: "是否前往创作特征？",
  createTraitConfirm: "前往创作特征页面会丢失当前编辑的内容，确认前往创作吗？",
  twoFinger: "双指拖动",

  switchingAccount: "正在切换账号...",
  deletingAccount: "正在删除账户...",
  customPoseTip:
    "建议使用平台预设的画面风格，自定义画面风格麻烦多加点提示词，不然画面可能会很奇怪哦",
  mutiUserTip: "建议使用自定义画面风格，不然画面可能会很奇怪哦",

  applyPending: "申请成功，请等待审核哟～",
  swapping: "兑换中...",
  exchangeSuccess: "兑换成功",

  notEnoughCrystal: "没有足够的水晶",

  uploadNotAllow: "该资源含有敏感信息，请重新上传。",
  tapToClose: "-点击关闭-",

  deleteReplyConfirm: "确认删除该评论吗？",
  reportTip: "请输入举报理由",
  blockUserConfirm: "确认拉黑该用户吗？",
  blockReplyContent: "【该评论已被删除】",
  opSuccess: "操作成功",

  imageLoading: "图片加载中",
  imageLoadFailed: "图片加载失败",
  imageReload: "重新加载图片",
  mateTraitNotExist: "该特征已被删除，无法编辑。",
  type: "类型",
  discussion: "讨论",
  mineCharacter: "我的",
  clearPromptMessage: "确定要清空提示信息吗？",
  totalCount: "总计",

  donateSuccess: "打赏成功",
  donateTooHigh: "打赏金额过高。最高金额为10000",
  donateTooLow: "打赏金额过低。最低金额为{amount}",
  default: "默认",
  custom: "自定义",
  noThumbnail: "无缩略图",
  removeThumbnail: "移除缩略图",
  textGeneration: {
    generate: "找灵感",
    continue: "追加",
    overwrite: "覆盖",
    inspiredText: "灵感文本",
    text: "纯文本",
    preview: "预览",
    emptyText: "请在纯文本模式下输入以获取Markdown预览",
    inspirePlaceholder: "用于生成{label}的关键词",
  },
  chatInModulePageTip:
    "要与当前角色聊天，当前更改将被提交并离开此编辑页面以选择另一个角色开始聊天。确定吗？",
  notAllowInjection: "此角色不允许关系注入",
  unfiltered: "未过滤",
  filtered: "已过滤",
  longImage: "长图",
  azureError: "上传的图片需要小于4MB",
  searchForSuitableForChat: "仅搜索适合聊天的内容",
  createNewTag: "创作",
  presetTag: "推荐",
  fillRequiredFields: "请填写必填字段",
  joinDiscordTip:
    "加入Discord！每天最多可获得<span class='text-primary-content font-bold'>100次免费聊天</span>！",
  redeemLoginTip: "登录以释放您的免费聊天限制",
  congratulations: "恭喜！",
  redeemSuccessTip: "您的免费聊天限制已增加到每天100次",
  restFreeChat: "今日剩余免费聊天",
  pleaseInputTargetName: "请输入目标名称",
  pleaseInputNumericalName: "请输入数值名称",

  // targetReaction
  reactionNumberError: "反应数值范围错误，请检查",
  pleaseFillChatSceneName: "请先填写场景名称",
  pleaseFillChatSceneDescription: "请先填写场景描述",
  pleaseFillReactionName: "请先填写反应名称",

  // chatScene event
  pleaseFillChatSceneEventName: "请先填写事件名称",
  chatSceneEventProbabilityError: "事件概率不能为0",
  pleaseFillChatSceneEventDefinition: "请先填写事件定义",
  pleaseAddEventFirst: "没有可用的事件，请先添加事件",

  serverUpgradingTitle: "服务器维护",
  serverUpgrading: `我们将于 {startTime} - {endTime} 进行计划中的服务器维护。在此期间，AI聊天和AI绘图服务将暂时不可用。此维护是确保平台持续性能和稳定性的必要措施。

我们对此给您带来的不便深表歉意，并感谢您的理解。`,

  none: "暂无",
  clickToFill: "点击填写",
  xCount: "{count}个",

  titleRequired: "请输入标题",
  nameRequired: "请输入名称",
  descriptionRequired: "请输入描述",

  notFriend: "请先添加 Ta 为好友",

  createImageInfo:
    "垫图功能正在谨慎评估中...有图片需求请先添加工作人员微信，暗号：“图片”，我们会尽快帮您制作！",

  bindSuccess: "绑定成功",

  inviterMessage: "【{mate}的专属邀请链接】\n",
  inviterMessage2:
    "复制链接在浏览器打开，注册成功后将会有能量块奖励哦！→ {link}",

  noPermissionToViewRole: "暂无权限查看该角色",

  dragModuleToSort: "长按拖动模块以排序",

  createTemplate: "另存为",
  createTemplateTitle: "名称",
  clickToImport: "点击选择要导入的模块",
  importTemplateTitle: "导入模块",
  importTemplateInfo: "确定要导入该模块吗？",
  importTemplateSuccess: "模块导入成功",
  failImportTemplate: "模块导入失败",

  deleteTemplateTitle: "删除可复用模块",
  deleteTemplateInfo: "确定要删除该可复用模块吗？",
  deleteTemplateSuccess: "可复用模块删除成功",
  failDeleteTemplate: "可复用模块删除失败",

  noTemplateAvailable: "没有可用的模块，请先去自定义模块中另存为吧！",
  importingTemplate: "正在导入模块...",
  deletingTemplate: "正在删除模块...",

  oversize: "文件大小不能超过 {size} MB",

  noAttribute: "暂无自定义属性，点击下方按钮添加吧！",
  cannotEditPresetModule: "无法编辑预设模块名称",
  settingSuccess: "设置成功",

  contentHasAiContent: "包含AI生成内容",
  contentIsAiGenerated: "该内容使用AI创作",

  timelineOrderDuplicate:
    "该排序ID: {order} 已存在，是否需要自动把所有后续的排序ID + 1？",
  updatingTimeline: "正在更新排序...",
  registerFirst: "您还没有注册账户，请先进行注册",

  deletePresetCharacter: "确认要删除该预设角色吗？",
  deletePresetCharacterConfirm: "删除后将无法恢复，确认删除吗？",

  cannotDeleteThisPlanet: "该星球有关联的角色，无法删除",
  cannotDeleteThisPlanet2: "最后一个星球无法删除",

  loadingPlanet: "正在加载星球...",

  confirmRemoveRelation: "确定要删除该关联吗？",

  publishMateFillWorldview: "请先选择星球",
  publishMateFillName: "请先填写角色名称",

  underConstruction: "正在努力建设中...",
  purchaseSuccess: "购买成功",
  verificationFailed: "验证失败",
  deleteAccountSuccess: "账户删除成功",
  createSampleOC: "正在为您创建样例OC..",

  registerToStart: "注册后开启你的 OC 创作之旅",
  androidVersionTip:
    "此功能在荣耀及安卓版本较低的机型中可能发生闪退。若发生此情况，请尝试使用QQ浏览器打开。",
  processingPayment: "正在处理您的支付...",
  creatingOrder: "正在创建订单...",
  confirmPayment: "请确认支付是否已完成",
  paymentNotCompleted: "尚未完成支付",
  crystalPaymentSuccess: "您购买的{count}个水晶已充值到您的账户中",

  removeFromPool: "确定要将 {name} 从OC互动池中移除吗？",

  deleteFriendConfirm: "确定要删除该好友吗？",
  deleteJournalConfirm: "确定要删除该日志吗？",

  overwriteConfirm: "确定要覆盖当前内容吗？",
  overwriteConfirmDesc: "确认后将清空当前内容",
  enableEnterPoolConfirm: "发布并将角色放入互动池",
  enableEnterPoolConfirmDesc:
    "在互动池中的角色可以主动与您及其他角色互动（加入互动池后，{label}将对其他用户公开）",

  targetGeneration: "目标生成中...",
  difficultyLevelGeneration: "任务难度评估中...",
  filterAlbum: "根据角色筛选稿件",
  uploadToWhichAlbum: "上传到哪一个角色的稿件中？",
  saveToAlbum: "保存到稿件",
  savingFailed: "保存失败",
  sticky: "常驻屏幕",

  noDriftCategory: "都被捞完了，晚点再来看看叭～",

  generating: "努力生成中...",
  howToGetMate: "你想通过哪种方式获取伙伴？",
  howToGetSelfAvatar: "你想通过哪种方式获取自设？",

  unNamedMate: "您还有未命名的伙伴，确定要创建一个新的伙伴吗？",
  unNamedSelfAvatar: "您还有未命名的自设，确定要创建一个新的自设吗？",

  notEnoughEquipmentInventorySpace: "装备背包容量不足",
  notEnoughEquipmentInventorySpaceDesc: "前往清理背包",

  contactCustomerService: "客服",
  contactCustomerServiceDesc: "请加入qq群795055136咨询工作人员",

  getThing: "获得物品",
  hasLocked: "已锁定",
  s: "的",

  cannotGetCanvasContext: "无法获取canvas context",
  cannotCreateBlob: "无法创建blob",
  tips: "提示",

  changeObjective: "变更该项会清除现有目标，是否继续？",

  queueExceedLimit: "队列大小超出限制，提前中止填充操作",
  indexOutOfRange: "索引 {index} 超出范围 [0, {length} - 1]",
  positivePrompt: "女孩子，看着镜头，开心，手绘",
  guidUserString: "随便画一画",

  confirmToEditPreset: "确定使用该预设覆盖当前形象吗？",

  responseYou: "响应了你",

  contactCustomerServiceDesc2: "如有问题，请加入qq群795055136咨询工作人员",
  spriteGeneratedSuccess: "伙伴形象生成完成！",
  taskCreating: "任务创建中...",
  taskCreatedSuccess: "任务创建成功！",
  mateCreatedSuccess: "伙伴创建成功！",
  mateLimit: "您最多只能创建10个伙伴",

  memberBenefit: "会员权益",
  free: "免费",
};

const Reply = {
  reply: "回复",
  replies: "回复",
  saysomething: "说点什么...",
  enterYourReply: "填写回复",
  popular: "热门评论",
  reader: "读者评论",
  noComments: "暂无评论",
  noCommentsDesc: "还没有人评论哦",
  edit: "编辑回复",
};

const Media = {
  uploadFailed: "上传失败",
  fileSizeExceed: "文件大小不能超过 {size} MB",
  fileFormatDisallowed: "文件格式只支持 {extension}",
};

const ConfirmModal = {
  areYouSureResetCanvas: "确定要重置画布吗？",
  clearCanvas: "重置后将清空画布上的所有内容",
  cancelEditInfo: "信息尚未保存，确定要取消编辑吗？",
  confirmApptovalTitle: "确认通过",
  confirmApptovalInfo:
    "通过后这条饼友圈会加入你的饼友圈中，并且所有人都可以看到",
  confirmRejectionTitle: "确认拒绝",
  confirmRejectionInfo: "拒绝这条饼友圈加入你的饼友圈中",
  deleteExampleTitle: "删除聊天样例",
  deleteExampleInfo: "确定要删除该聊天样例吗？",
  deleteMateTitle: "删除角色",
  deleteMateInfo: "这个操作将无法恢复，确认删除当前角色吗？",
  deleteModuleAllInfo: "这个操作将无法恢复，确认删除吗？",
  deleteAttributeTitle: "删除属性",
  deleteAttributeInfo: "确认删除当前属性吗？",
  deleteModuleTitle: "删除模块",
  deleteModuleInfo: "确认删除当前模块？",
  cancelEditingTitle: "取消编辑",
  cancelEditingInfo: "确认取消对当前角色的编辑吗？",
  deletePrivateChatTitle: "删除对话",
  deletePrivateChatInfo: "确定要删除对话吗？",
  exitTitle: "确认退出",
  promptTitle: "提示",
  deleteCharacterImage: "确定删除人物参考图吗？",
  goingEditInfo: "前往词库将会丢失提示词，确认前往编辑吗？",
  switchCharacterImageInfo: "切换角色会清空已选图片，是否继续？",
  clearTheCanvas: "确定要清空画布吗？",
  deleteCurrentChatTitle: "删除聊天",
  deleteCurrentChatInfo: "删除后将无法恢复，确定删除吗？",
  deleteChapter: "删除章节",
  confirmDeleteReply: "确定删除评论吗？",
  deleteReplyCannotRecovered: "删除的评论将无法恢复",
  confirmDeleteThisMoment: "确定删除这条饼友圈吗？",
  confirmDeleteThisSecret: "确定删除这条秘密吗？",
  deleteMomentCannotRecovered: "删除的饼友圈将无法恢复",
  deleteSecretCannotRecovered: "删除的秘密将无法恢复",
  areYouSureDeleteNode: "确定删除该节点吗？",

  cancelPublish: "取消发布",
  cancelPublishInfo: "你的帖子还未发布，确定要取消吗？",
  deleteCharacter: "确定要删除该角色吗？",

  googleLoginTitle: "请在新窗口登录",
  googleLoginInfo: "是否已经在新窗口登录成功？",

  confirmTitle: "确认",
  notSaved: "未保存",
  confirmInit: "确认初始化吗？",
  confirmSaveChanges: "确认保存修改吗？",
  confirmNotSave: "确认不保存吗？",
  sureDeleteDisplayText: "确定删除{displayText}吗？",
  unfollowTitle: "取消关注",
  sureUnfollowText: "确认要取消关注{name}吗？",

  cancelCreation: "取消创作",
  cancelCreationText: "创作还未提交，确定要取消吗？",

  sureDeleteImageText: "确定删除该图片吗？",

  saveNotCompleteText:
    "保存将会不补全内容，直接采用当前章节内容，确定保存并生成章节吗？",

  clearTitle: "清空",
  sureClearText: "确定清空吗？",

  sureDeletePost: "确定要删除该饼友圈？",
  sureDeleteText: "确定删除吗？",

  deleteDialogue: "删除对话",
  deleteDialogueText: "确定要删除这条对话吗?",
  deleteOption: "删除选项",
  deleteOptionText: "确定要删除这个选项吗？",
  enterContent: "输入内容",
  rating: "评分",

  deleteNode: "删除节点",
  deleteNodeText:
    "删除节点后，该节点的所有内容将被删除，且无法恢复，是否确认删除？",
  deleteCharacterText: "删除角色之后会删除该角色的所有对话",

  protagonistExists: "已经有主角了",
  protagonistExistsText: "是否切换主角？",
  deleteActivationCondition: "确定要删除该节点的激活条件吗？",

  sureSwitchTitle: "确定切换到另一个对话吗？",
  sureSwitchDesc: "切换后当前对话的画布内容会被保存",

  sureOverrideTitle: "确定应用到画布吗？",
  sureOverrideDesc: "当前画布的内容会被覆盖",

  sureBatchOverrideTitle: "确定批量应用吗？",
  sureBatchOverrideDesc: "批量应用后，当前画布的内容将会覆盖到所有选中的对话中",

  deleteMusic: "删除音乐",
  deleteMusicText: "确定删除该音乐吗？",

  deleteTone: "删除音色",
  deleteToneText: "确定删除该音色吗？",
  clearContent: "清空内容",
  clearContentText: "确定清空内容吗？",

  deleteMessage: "删除消息",
  deleteMessageText: "确定删除这条消息吗？",
  modifyMessage: "修改消息",
  modifyMessageText: "确定修改这条消息吗？",

  confirmDeleteCollectionItem: "确定删除该合集项吗？",

  enableAutoPlay: "启用语音自动播放",
  enableAutoPlayDesc: "语音自动播放会有更好的沉浸感",
  enableAutoPlayDesc2: "由于浏览器限制，每次刷新后需要您确认后才能启用自动播放",
  autoPlayOk: "启动！",
  autoPlayCancel: "大可不必",
  deleteAccountTip:
    "本操作无法恢复，这将会永久删除您的账户，您的所有角色也会被删除。",
  deleteAccountTip2: "以下{count}个角色也将被删除",
  inputEmailOrPhoneToConfirm: "请输入您的邮箱或手机号进行确认",
  permanentlyDelete: "永久删除账户和{count}个角色",
  notSupportMateSwitchTitle: "当前页面不支持切换角色",
  notSupportMateSwitchDesc: "确认切换您将回到首页",
  reloadApp: "重新加载应用",
  reloadAppDesc: "修改该选项需要重新加载应用来让设置生效",

  confirmToEditWorldview: "确定前往编辑该星球吗？",
  confirmToRemoveAllPreset: "确定要删除所有预设OC吗？",

  selfAnswer: "让OC自己答，将会清空您的回答，并会消耗{count}个能量块。确定吗？",
};

const Community = {
  fork: "分支: ",
  gen: "几代: ",
  chat: "聊天: ",
  publishedAt: "发布时间: ",
  hot: "最热",
  new: "最新",
  top: "排行",
  current: "当前",
  thGen: "第 {number} 代",
  root: "源",
  showGenealogy: "展示迭代",
  dungeon: "OC演出",
  socialSetting: "联机设定",
  moment: "饼友圈",
  story: "OC故事",
  video: "视频",
  game: "视觉小说",
  galGame: "视觉小说",
  rank: "互动排行",
  gallery: "画廊",
  myOCMoments: "我和我的OC",
  friendsMoments: "好友",
  starPlanet: "精选星球",
};

const Overview = {
  info: "信息",
  type: "类别",
  birthday: "生日",
  generation: "迭代",
  forkCount: "分支",
  likes: "喜欢",
  comments: "评论",
  feedback: "玩家反馈",
  storyFeedback: "读者反馈",
  overview: "概述",
  popularSnippets: "片段节选",
  genealogy: "谱系图",
  reviews: "评价",
  updateTime: "修改时间",
};

const Image = {
  info: "信息",
  size: "尺寸",
  date: "日期",
  type: "类别",
  originalImage: "原图",
  partialRedraw: "局部重绘",
  smudgeRetouching: "涂抹修图",
  fusionRedraw: "融合重绘",
  redraw: {
    handRepair: "手部修复",
    addObject: "添加物体",
    detailRepair: "细节修复",
    deleteObject: "删除物体",
    changeClothes: "更换服饰",
    changeExpression: "更换表情",
  },
};

const Empty = {
  emptyImage: "现在还没有图片",
  emptySearchImageTitle: "没有找到相关图片",
  emptySearchImageDesc:
    "换个关键词试试看，使用生成图片时常用的关键词会有更好的效果哦",
  emptySearchFilter: "暂无可用的筛选条件",

  friendList: {
    title: "暂无好友",
    desc: "快去添加好友吧",
  },

  loginFirst: {
    moments: "登录后就可以浏览和发布饼友圈啦",
  },
  mateSelect: {
    noCharacterAvailable: "没有已发布的角色",
    pleaseCreateNewCharacter: "创建角色并发布后，您可以在这里选择Ta",
  },
};

const Notifications = {
  receiveNewNotification: "收到新通知",
  title: "通知",
  unread: "未读",
  read: "已读",

  btn: {
    allRead: "将所有标为已读",
  },

  message: {
    characterNotExist: "角色不存在",
  },

  type: {
    agreedGuardianRequest: "同意了您的好友申请",
    declinedGuardianRequest: "拒绝了您的好友申请",
    replyMentioned: "{mateName} 评论中提到了你：",
    repliedMoment: "{mateName} 评论了你的饼友圈",
    repliedTextImage: "{mateName} 评论的你的图片",
    repliedComment: "{mateName} 回复了你的评论",
    wantGuardYou: "{mateName} 想要添加你为好友",
    mentionedMoment: "{mateName} 饼友圈中提到了你",
    storyVideoGenerated: "故事：{title}视频已生成",
    storyGenerated: "故事: {title} 已生成",
    approvedContentCreated: "通过了你为Ta创作的内容",
    declinedContentCreated: "拒绝了你为Ta创作的内容",
    followedYou: "关注了你",
    guardedYou: "成为了你的好友",
    messageFrom: "来自{mateName}的消息",
    createContentForYou: "{mateName}为你创作了内容",
    imageGenerationComplete: "图片生成完成",
    likeMoment: "{mateName} 点赞了你的饼友圈",
    likeTextImage: "{mateName} 点赞了你的图片",
    donate: "{giver} 贡献了 ${amount}",
    coinVote: "{giver} 为你投了推荐票",
    becomeSeniorReader: "资深读者申请通过",
    collectionInvited: "{name} 邀请你加入了合集",
    superAdmireSuccess: "您的高级订阅申请已经通过啦！",
    superAdmireFailed: "您的高级订阅申请被拒绝了！",
    mediaPurchased: "{name} 购买了您的作品。您收到了 ${amount}",
    mateAdmireSubscribed: "{name} 已成功高级订阅了你。您收到了 ${amount}",
    ChatMessageEarned: "{name} 与您的角色聊天互动。您收到了 ${amount}",
    DispatchMissionReturn: "{name} 外派任务结束啦，快来迎接我吧！",
    WishCompleted: "祈愿已回响，快来看看！",
    mateAdopted: "{name} 被成功领养啦，快去看看！",
    mateMail: "{name} 给您发送了一封邮件",
    mateInvitation: "{name} 给您发送了一条互动消息，请前往审阅",
    houseEventGenerated: "小屋的事件已准备完毕",
    spriteGenerated: "{name} 的形象生成完成啦，快去看看！",
    mateGenerated: "角色 {name} 生成完成啦，快去看看！",
    memberSubscriptionReceived: "您已收到{name}的会员订阅奖励",
    memberSubscriptionReceivedDesc:
      "您已收到{name}的会员订阅奖励\n奖励内容为{powerAmount}能量块",

    memberSubscriptionReceivedGenerateTimes:
      "\n简单模式生成角色{generateTimes}次",

    userTaskCompleted: "您已完成 {name} 的任务，赶快来领取奖励吧",
    userShareReward: "分享活动：{status}",
  },

  userShareReward: {
    2: "审核通过",
    3: "审核未通过",
    approveView:
      "您提交的分享笔记截图已通过审核，我们已将{powerCubes}能量块发放到了您的账户中",
    rejectView: "您提交的截图不满足发放要求",
  },

  system: "系统通知",
  guardingCanceled: "已取消守护",
  subType: {
    comment: "评论",
    reaction: "点赞",
    follow: "关注",
    admire: "好友申请",
    income: "收益",
    vote: "投票",
    system: "系统",
  },
};

const MateType = {
  original: "原创角色",
  fan: "二次创作",
  1: "原创角色",
  2: "二次创作",
  3: "创作者",
  4: "自设",
  create: {
    1: "伙伴",
    2: "伙伴",
    3: "人物",
    4: "自设",
  },
};

const Visibilities = {
  visibilityTitle: "谁可以看到",
  public: "公开",
  private: "私密",
  onlyFollower: "仅关注者",
  onlyAdmire: "仅好友",
  publicDesc: "发布到饼友圈，所有人都可以看到",
  privateDesc: "仅自己可见",
  onlyFollowerDesc: "仅关注当前角色的人可见",
  onlyAdmireDesc: "仅你的好友可见",
  status: {
    1: "公开",
    2: "私密",
    3: "仅关注者可见",
    4: "仅好友可见",
    5: "隐藏",
    6: "付费者可见",
    7: "高级订阅者可见",
  },
};

// 特征
const trait = {
  traitPreview: "特征预览",
  positive: "正向",
  negative: "负向",
  feature: {
    extraction: "特征提取",
    selected: "已选择标签",
    description: "特征描述",
    clone: "克隆",
  },
  image: "待提取图片",
  select: "选择图片",
  reselect: "重新选择",
  copy: "复制提示词",
  import: "从其他角色导入",
  new: "创作",

  tab: {
    artStyle: "画面风格",
    img: "参考图",
    descriptors: "描述词",
  },

  edit: {
    title: "人物特征",
    clone: "克隆特征",
  },

  random: "随机",
  characterImage: "人物参考图",
  generatePreview: "生成预览",
  traitName: "特征名称",
  traitDescription: "特征描述",
  showPromptWords: "展示提示词",
  traitCover: "特征封面",
  changeCover: "更换封面",
  autoPrompt: "自动解析图片并追加到提示词",

  description: "描述",
  expression: "表情",
  placeholder: "请选择或输入提示词...",

  tagAction: {
    weight: "权重",
    labelWeight: "左滑删除权重",
  },

  setWeight: "设置权重",
  delete: "删除",
  done: "完成",

  artStyleTitle: "请选择一个你喜欢的风格",

  mode: {
    preset: "预设特征（适合二创）",
    custom: "自定义（适合OC创作）",
    0: "v0（可混合模型）",
    1: "v1（适合OC创作）",
    2: "v2（适合二创）",
  },
};

// 绘画
const painting = {
  individual: "单人",
  multiplePeople: "多人",
  iLike: "我喜欢的",
  custom: "自定义",
  selected: "已选中",
  prompt: "描述词",
  global: "全局",
  people: {
    title: "人物",
    feature: "人物特征",
    noFeatureInfo: "你还没有为Ta创作任何图哦",
    noFeatureInfoDesc: "创作特征可让每次生成都是同一角色",
    new: "新建",
    edit: "编辑",
    create: "去创作",
    beforeCreate: "创作特征后可以选择人物{type}",
    faceExpression: "表情",
    pose: "姿势",
    poses: "组合姿势",
    poseSelect: "姿势图",
    posePreset: "预设姿势图",
    poseDiy: "自定义姿势",
    newPoseDiy: "新建自定义姿势",
    select: "选择参考图",
    upload: "上传参考图",
    uploadPose: "上传姿势图",
    clothing: "服饰",
    import: "从衣帽间导入",

    position: "侧重部位",
    position1: "全身",
    position2: "脸部",
  },
  layout: {
    title: "参考图",
    img: "布局参考图",
    upload: "上传布局参考图",
    weight: "参考图权重",
    pose: "人物姿势参考图",
  },
  origin: {
    title: "原图",
    upload: "上传图片",
    weight: "参考图权重",
  },
  env: {
    title: "视角与环境",
    desc: "环境描述",
    import: "从场景包导入",
  },
  single: {
    selectCharacter: "人物特征还没有选择哦",
  },

  muti: {
    addMate: "添加角色",
    selectMate: "选择角色",
    selectTrait: "选择特征",
    selectCharacter: "角色至少需要选择两个哦",
    noGirlOrBoyTips:
      "角色 {name} 没有性别特征的提示词，建议为其添加 1girl 或 1boy 特征提示词，否则的话生成的图片可能会有问题哦。",
    continue: "继续生图",
  },
  replace: {
    title: "待替换图",
    selectCharacter: "替换为的特征还没有选择哦",
    selectImage: "待替换的图片还没有上传哦",
  },
  replaceWith: {
    title: "替换为",
  },
  emoji: {
    selectImage: "原始图片尚未上传",
    inputPrompt: "表情提示词尚未输入",
  },
  setting: "生成设置",
  pages: "张数",
  proportion: "比例",
  numberGeneratedImages: "生成图片数",

  featuresCueWord: "特征和提示词",
  englishCueWords: "英文提示词",
  enterEnglishCueWordsText: "请输入英文提示词，以逗号分割",
  // 表情

  style: {
    title: "画面风格",
    preset: "平台预设",
    custom: "自定义",
    select: "选择风格",
    selectTip: "多选开启融合封印",
    mixSetting: "融合设置",
    styleId: "画风 ID",
    consistency: "浓度",
    modelVersion: "模型版本",
    mixSettingError: "融合比例之和需为 1",
    must2: "最多选择 2 个画风进行融合",
  },

  switchMuti: "切换到多人",
  switchSingle: "切换到单人",

  poses: {
    "stand by stand": "并肩站",
    kiss: "亲吻",
    hug: "拥抱",
  },

  nsfwNotice: "nsfw目前只支持自定义画风，已将画风调整为v2（适合二创）",
  envIsNsfwCannotCloseNsfw:
    "布局参考包含敏感信息，无法禁用nsfw。请删除后重试。",
  originIsNsfwCannotCloseNsfw: "原始图片包含敏感信息，无法禁用nsfw。",

  traitType: {
    preset: {
      title: "预设 （适合新人AI绘画创作者）",
      titleSimple: "预设",
      content:
        "搜索喜爱的动漫人物，将其存为自己的形象特征，之后可以简单的调用此二次元形象特征，生成更多的图片或视频。​",
    },
    text: {
      title: "文生特征",
      content:
        "可以输入任意提示词，据此生成二次元形象特征，之后可以简单的调用此二次元形象特征，生成更多的图片或视频。​",
    },
    img: {
      title: "图生特征",
      content:
        "可以上传任意人物的图片/照片，据此生成二次元形象特征，之后可调用次形象特征，生成更多的图片或视频。​",
    },
    mix: {
      title: "混合 (适合深度AI绘画创作者)",
      content:
        "可以输入任意提示词+图片/照片，并可控制搭配权重，适合AI深度创作者。",
    },
  },

  paintType: {
    text: {
      title: "文生图片",
      content: "你可以输入任意的提示词去生成图片",
      single: "单人",
      multi: "多人",
      nobody: "无人",
    },
    img: {
      title: "图生图片",
      content:
        "你可以上传任意参考图片，将它转变成你喜欢的二次元风格，或是将其中的人物替换成你喜欢的二次元人物​",
      repaint: "转绘",
      replace: "更换人物",
      emoji: "表情",
    },
    mix: {
      title: "混合图片",
      content:
        "可以输入任意提示词+图片/照片，并可控制搭配权重，适合AI深度创作者。",
      name: "混合",
    },
  },

  promptUpdate: {
    title: "细化提示词",
    origin: "原提示词",
    new: "新提示词",
    confirmReplace: "确认将新的提示词替换掉原提示词吗？",
    regenerate: "重新生成",
  },

  styles: {
    "3D graphics": "3D 图形",
    cinematic_lighting: "电影照明",
    "magazine cover": "杂志封面",
    "4koma": "四格漫画",
    "comic book": "漫画书",
    "marker_(medium)": "马克笔（媒介）",
    Impasto: "厚涂",
    futurism: "未来主义",
    monochrome: "单色",
    "Polaroid art": "宝丽来艺术",
    "genshin impact": "原神",
    "pixel art": "像素艺术",
    "Studio Ghibli": "吉卜力工作室",
    "glowing neon lights": "发光霓虹灯",
    "rebecca (cyberpunk)": "丽贝卡（赛博朋克）",
    "alphonse mucha": "阿尔丰斯·穆夏",
    goth: "哥特",
    "retro_arf style": "复古风格",
    "art nouveau": "新艺术",
    lens_flare: "镜头光晕",
    silhouette: "剪影",
    "azur lane": "碧蓝航线",
    light_rays: "光线",
    "vibrant colors": "鲜艳的颜色",
    backlighting: "背光",
    lineart: "线稿",
    watercolor: "水彩",
  },
};

const task = {
  type: ["等待中", "待标记", "优质", "废弃"],
  btn: {
    high: "优质",
    img1: "存入{chapter}相册",
    chapter: "章节",
    edit: "编辑",
    delete: "废弃",
    more: "更多",
    gif: "生成动图",
    emoji: "存为新特征",
    emoji1: "覆盖原特征",
    info: "查看详情",
    brush: "重绘",
    image: "延展",
    download: "下载 HD",
    "eye-regular": "转为公开展示",
    "eye-slash": "转为不公开展示",
  },
  deleteTip: "15天后自动删除",
  status: {
    pending: "排队中",
    processing: "生成中",
    timeout: "网络超时,请刷新重试",
  },
  tab: {
    All: "所有",
    MateTrait: "特征",
    StoryImage: "故事配图",
    StoryVideo: "故事视频",
    TextGif: "饼友圈图片",
    TextImage: "绘图",
    ReplaceImageCharacter: "替换人物",
    CreateMultiuserImage: "创作多人图",
  },

  createAIGenerationTask: "创作AI生成任务",
};

const userTask = {
  status: {
    all: "全部",
    [UserTaskStatus.IN_PROGRESS]: "未完成",
    [UserTaskStatus.COMPLETED]: "已完成",
    [UserTaskStatus.CLAIMED]: "已领取",
  },
  type: {
    [UserTaskType.MAINQUEST]: "主线任务",
    [UserTaskType.SIDEQUEST]: "支线任务",
  },
};

const story = {
  save: "暂存",
  generate: "生成",
  auto: "自动生成",
  draft: "草稿",
  published: "已发布",
  publishedOn: "发布于",
  editOn: "最后编辑于",
  collectedOn: "收录于",
  status: "状态",
  loadThreeMore: "加载三个章节",
  new: "最新",
  old: "最早",
  newStory: "新的故事",
  editStory: "编辑故事",
  storyDescription: "故事描述",
  name: "故事名称",
  cover: "故事封面",
  visibility: "故事可见性",
  delete: "删除故事",
  deleteDesc: "将删除故事及其所有章节，删除后将无法恢复，确定删除吗？",
  processing: "生成中",
  generatingStory: "正在生成故事...",
  generatingStoryChapter: "正在生成故事章节...",
  generateTime: "生成开始时间",
  generateTimeMinutes: "生成时间约为1-2分钟",
  waitTimeMinutes: "等待时间约为1-2分钟",
  chapterGeneration: "章节内容生成中",
  moreStory: "来自作者的更多故事",
  read: "阅读",
  readFullContent: "点击阅读查看全文",
  wordCount: "字数",
  like: "喜欢",
  selectTheTypeChapterDownload: "选择章节下载的类型",
  image: "图片",
  info: "信息",
  createAt: "创作时间",
  publishedAt: "发布时间",
  author: "作者",
  readMethod: "阅读方式",
  viewVideo: "看视频",
  immersiveMode: "沉浸模式",

  tab: {
    content: "内容",
    chapter: "章节",
    moment: "随记",
    gallery: "画廊",
  },
  base: {
    title: "基本信息",
    type: "类型",
    edit: "编辑",
    addRole: "添加角色",
    summary: "故事简述",
    relation: "关联饼友圈",
    add: "添加",
  },
  role: {
    title: "故事人物",
    chapter: "章节人物",
    add: "添加角色",
    my: "我的OC",
    admiring: "守护中",
    admire: "守护者",
    select: "选择",
    1: "主角",
    2: "配角",
  },
  style: {
    title: "文风参考",
    demo: "文风样例",
    select: "选择已有章节",
  },
  g: {
    // 自动生成
    title: "自动生成参考的内容",
    type: "故事类型",
    characterzz: "故事人物",
    description: "故事简述",
    momentIdzz: "关联饼友圈",
    exampleText: "文风样例",
    beginning: "章节开头",
    previousStoryId: "前置章节",
    ending: "章节结尾",
    cancel: "取消",
    basedPrev: "根据上文",
    basedNext: "根据下文",
    basedContext: "根据上下文",
    generatedFromMoment: "从饼友圈生成",
    writingStory: "AI正在编写故事",
  },
  setting: {
    title: "剧情设置",
    prevChapter: "前置章节",
    select: "选择前置章节",
    chapterStart: "本章开头",
    add: "增加内容节点",
    chapterEnd: "本章结尾",
    node: "内容节点",
    beginning: "开头",
    body: "正文",
    ending: "结尾",
  },
  type: {
    1: "奇幻",
    2: "科幻",
    3: "冒险",
    4: "悬疑",
    5: "惊悚",
    6: "犯罪",
    7: "历史",
    8: "传记",
    9: "文学",
    10: "言情",
    11: "青春",
    12: "幽默",
    13: "恐怖",
    14: "战争",
    15: "社会小说",
    16: "家庭",
    17: "心理小说",
    18: "科幻恐怖",
    19: "奇幻冒险",
    20: "历史奇幻",
    21: "神秘",
    22: "童话",
    23: "幻想",
    24: "短篇小说",
    25: "现实主义",
    26: "黑色喜剧",
    27: "自传",
    28: "幻想史诗",
    29: "神话",
  },

  afterPosting5Update: "只有在发布了5条饼友圈后才可以创作故事集",
  storyChapter: "故事章节",
  selectStoryChapters: "选择故事章节",
  generateVideoText: "选择一个故事章节，AI将根据章节内容生成视频",
  generateIllustrationsText: "选择一个故事章节，AI将根据章节内容生成一些配图",
  narratorVoice: "选择叙述人声音",
  aNarratorVoice: "选择一个作为叙述人的声音",
  backgroundMusic: "背景音乐营造的氛围",
  selectChapter: "选择章节",
  readBegin: "从头阅读",
  noChaptersAvailable: "暂无章节",
  noChapterAvailableYet: "暂无可用章节",
  currentCreatedChapters: "当前角色还没有创作章节",
  currentStoryNoChapterCreatedYet: "当前故事还没有创作章节",
  selectVoice: "选择音色",

  storyHalf: "您有 ",
  storyFinal: "个章节未添加到故事，点击进行添加",
  ongoing: "连载至第",
  ongoingTwo: "章",
  newChapter: "新的章节",
  chapterEditing: "编辑章节",
  chapterTitle: "章节名称",
  chapterDescription: "章节描述",
  chapterCover: "章节封面",
  chapterCoverVideo: "章节封面视频",

  separatorSymbol: "分割符号",
  enterSeparatorSymbol: "请输入分隔符",

  typePlaceholder: "点击选择类型",

  totalWords: "共{number}字",
  tellYourStory: "讲述你的故事...",

  insertImgMode: "插图模式",
  body: "正文",
  generated: "已生成",
  notGenerate: "未生成",

  imgText: "图文：",
  video: "视频：",
  visualNovel: "视觉小说：",

  chapterInfo: "章节信息",

  createVideo: "生成视频",
  createVisualNovel: "生成视觉小说",

  immersiveRead: "沉浸阅读",
  imgTextRead: "图文阅读",
  chapterStart: "章节开始",
  chapterEnd: "章节结束",
};

const SidebarNavi = {
  home: "主页",
  discover: "发现",
  conversation: "对话",
  role: "角色",

  post: "发布",
  moment: "饼友圈",
  profile: "资料",
  gallery: "相册",
  chat: "聊天",
  imageWorkshop: "AI绘图",
  request: "审阅",
  setting: "设置",
  language: "更换语言",
  logout: "登出",
  account: "账户",
  switch: "切换角色",
  currentMate: "选择角色",
  new: "新建角色",
  clearCache: "清除缓存",
  version: "当前版本",
  checkUpdate: "检查更新",

  downloadApp: "下载App",
  feedback: "社区/社交媒体",
  wechat: "微信",
  timeline: "时间线",
  joinGroupQrcode: "入群二维码",
  joinGroupTip: "长按保存到相册，用微信扫一扫入群交流。",

  appearanceSetting: "外观设置",
  chatAppearanceSettings: "对话外观设置",
  dark: "深色",
  light: "浅色",
  auto: "跟随系统",
  colorful: "多彩",
  classic: "经典",
  theme: "主题",
  themeMap: {
    auto: "跟随系统",
    light: "饼次元（亮色）",
    dark: "饼次元（暗色）",
    cupcake: "萌系甜点",
    bumblebee: "蜂酱暴走",
    emerald: "翡翠梦境",
    corporate: "社畜模式",
    synthwave: "电子幻音",
    retro: "昭和回忆",
    cyberpunk: "赛博废土",
    valentine: "心跳告白日",
    halloween: "百鬼夜行",
    garden: "花の庭院",
    forest: "森の秘境",
    aqua: "水色幻想",
    lofi: "低保真废柴",
    pastel: "马卡龙物语",
    fantasy: "异世界入口",
    wireframe: "代码视界",
    black: "虚空吞噬者",
    luxury: "土豪金MAX",
    dracula: "血族契约",
    cmyk: "彩虹工厂",
    autumn: "枫叶物语",
    business: "社长办公室",
    acid: "迷幻剂警告",
    lemonade: "柠檬汽水",
    night: "夜猫子联盟",
    coffee: "社畜续命水",
    winter: "雪国列车",
    dim: "暗黑系",
    nord: "北欧神话",
    sunset: "日落黄昏",
  },

  selectSetting: "在左侧选择一个设置",

  stopImpersonate: "退出模拟",
  beautify: "美颜",
  creation: "创世",
  playground: "乐园",
  partner: "伙伴",
  paradise: "乐园",
};

const setting = {
  selectSetting: "在左侧选择一个设置",
  account: "账户",
  appearance: "外观",
  language: "语言",
  preference: "偏好设置",
  chatTheme: "聊天主题",
  about: "关于",
  version: "版本",
  accountInfo: "账户信息",
  userName: "用户名称",
  powerCube: "能量块记录",
  billing: "账单",
  email: "邮箱",
  sensitiveContentPreference: "敏感内容偏好",
  phone: "手机号",
  bindEmail: "绑定邮箱",
  bindPhone: "绑定手机号",
  content: "内容设置",
  isBlockAiContent: "是否屏蔽AI内容",
  currentModel: "当前模型",

  lineMateCount: "一行展示几个伙伴？",
};

const Social = {
  followers: "关注者",
  admirer: "守护者",
  following: "正在关注",
  admiring: "守护中",
  likes: "喜欢",
  liked: "喜欢",

  admiringTitle: "暂无守护中的角色",
  admiringDesc: "还没有守护中的角色",
  admirerTitle: "暂无守护者",
  admirerDesc: "该角色还没有守护者",
  followingTitle: "暂无关注中",
  followingDesc: "还没有关注中的角色",
  followersTitle: "暂无正在关注",
  followersDesc: "还没有人关注这个角色",
  days: "天",
  you: "你",

  admirers: {
    guardingFor: "已经守护",
    justGuarded: "刚刚守护了",
  },

  actions: {
    cancelGuarding: "取消守护",
    deleteFriend: "删除好友",
    deleteFriendConfirm: "确定删除好友吗？",
  },
};

const MineMate = {
  post: "发饼友圈",
  profile: "编辑资料",
  gallery: "相册",
  chat: "聊天",
  imageWorkshop: "AI绘图",
  paint: "转绘",
  request: "审阅",
  setting: "设置",
  language: "语言",
  task: "任务",
  story: "故事",
  game: "视觉小说",
  gif: "动图",
  portrait: "特征与立绘",
  mutiImg: "多人图",
  storyVideo: "故事视频",

  tools: "制作工具",
  queue: "制作队列",
  create: "创作与发布",
  earn: "创作收益",
  profileSetting: "资料设置",
  createMate: "创建OC",

  mode: {
    easy: "简单模式",
    preset: "预设角色",
    driftCapsule: "打捞休眠仓",
    ocEditor: "OC编辑器",
    selfEditor: "自设编辑器",
    reference: "使用参考图",
  },
};

const Request = {
  pendingReview: "待审核",
  reviewed: "已审核",
  pendingTaReview: "待Ta审核",
  taReviewed: "Ta已审核",
  applyGuardYou: "申请成为你的好友",
  applyGuard: "好友申请",
  reviewTime: "审阅时间",
  status: {
    approved: "通过",
    rejected: "拒绝",
  },
};

const Cell = {
  willReduceMessage: "会减少类似的消息",
  himWillAlsoMessage: "Ta也会忘记这条消息",
  himMemoryWillModified: "Ta的记忆也会修改",
  basicInformation: "基本信息",
  photograph: "写真",
  interest: "兴趣",
  useAiDrawing: "使用AI绘图",
  useAiDrawingEmoji: "使用AI画表情",
  upload: "上传",
  image: "图片",
  video: "视频",
  characterSelect: "从角色稿件中选择",
  avatarSelect: "从头像中选择",
  worldviewSelect: "从星球稿件中选择",
  generatedImage: "从生成稿件中选择",
  chapterSelect: "从章节稿件中选择",
  portraitsSelect: "从立绘中选择",
  animationSelect: "从动画中选择",
  characterAlbum: "角色稿件",
  worldviewAlbum: "星球稿件",
  aiDrawing: "AI绘图",
  chapterAlbum: "章节稿件",
  cancel: "取消",
  useAvatar: "使用头像",
  editMoment: "编辑饼友圈",
  deleteMoment: "删除饼友圈",
  editSecret: "编辑秘密",
  deleteSecret: "删除秘密",
  editReply: "编辑评论",
  deleteReply: "删除评论",
  deleteCollectionItem: "删除合集项",

  delete: "删除",
  report: "举报",
  blockUser: "拉黑该用户",

  creatorType: "创作者类型",
  model: "模型",
  lastUpdatedTime: "最后更新时间",
  notSet: "未设置",
  likingCount: "收到的喜欢",
};

const bgm = {
  happy: "快乐开心",
  sad: "悲伤",
  angryIntense: "愤怒和强烈",
  fearfulAnxious: "恐惧紧张",
  gentleSoothing: "温柔舒缓",
  exciting: "刺激",
};

const Moment = {
  items: "条",
  selected: "已选择",
  countMoments: "条饼友圈",
  noSelectedMoment: "没有已选择的饼友圈",
  viewAllContent: "查看全部饼友圈内容",
  collaborativeCreation: "共同创作",
  character: "角色",
  moment: "饼友圈",
  expression: "表情",
  setting: "设置",
  todayHappened: "有什么想法？记录下吧！",
  sync: "同步",
  syncWorldviewTimeline: "同步OC所在星球({name})的时间线",
  syncMateTimeline: "同步OC的时间线",
};

const game = {
  processing: "生成中",
  producer: "制作人",
  selectGame: "选择游戏",
  audioName: "音频名称",
  name: "名称",
  recommendation: "推荐",
  selectContentNode: "选择内容节点",
  jumpAnotherNode: "跳转到其他节点",
  pleaseSelectDialogue: "请选择跳转的对话",
  notSet: "未设置",
  modify: "修改",
  createNewGame: "创作视觉小说",
  jumpToSettings: "跳转设置",
  playerResponse: "玩家回复选项",
  newGames: "新的游戏",
  author: "作者：",
  playTimes: "人次玩过",
  auto: "自动生成",
  player: "玩家",
  characterIntro: "人物介绍",
  gameType: "游戏类型：",
  version: "当前版本：",
  toGameDetailPage: "查看游戏详情页",
  videoAndScreenshot: "游戏视频 & 截图",
  notSetJump: "不设置跳转",
  tab: {
    title: "基本信息",
    endings: "结局",
    setting: "剧情设置",
  },
  base: {
    title: "基本信息",
    name: "名称",
    type: "游戏类型",
    description: "游戏简述",
    characterzz: "参与 Mate",
    characterIntro: "自我介绍",
    player: "玩家扮演",
    playerName: "玩家名称",
    playerAvatar: "玩家头像",

    playerIntro: "人物介绍",
    cover: "游戏封面图",
    edit: "编辑",
    backgroundMusic: "背景音乐",
    introduction: "自我介绍",
    selectCharacter: "选择参与 Mate",
  },
  role: {
    0: "所有",
    1: "主角",
    2: "配角",
    3: "玩家",
    4: "旁白",
  },
  show: {
    title: "演出设置",
    defaultTone: "默认音色",
    reselect: "重新选择",
    viewAllDialog: "查看全部对话",
    allDialog: "全部对话",
    resetTone: "重新生成所有音频",
    unselected: "未选择",
    selectTone: "选择音色",
  },
  roleTab: {
    my: "我的OC",
    myGuarded: "我守护的",
    guardians: "守护者",
  },
  toneMood: {
    1: "生气",
    2: "开心",
    3: "悲伤",
    4: "恐惧",
    5: "温和",
    6: "兴奋",
    9: "自定义",
  },
  ending: {
    title: "结局",
    add: "添加结局",
  },
  updateLog: {
    title: "更新日志",
    current: "当前版本号",
    later: "更新后版本号",
    content: "本次更新内容",
    version: "历史版本",
  },
  node: {
    conversation: "对话",
    conversationEdit: "编辑对话",
    conversationCount: "对话数量：",

    connect: "连接剧情",
    connectEdit: "编辑连接",
    enter: "进入当前节点",
    condition: "进入当前条件",
    trigger: "触发条件：",
    to: "前往节点",
  },
  type: {
    1: "恋爱",
    2: "生存",
    3: "探险",
  },

  actions: {
    playAudio: "播放音频",
    renewAudio: "重新生成音频",
    editAudio: "编辑音频",
    removeAudio: "移除音频",
    editImage: "编辑图片",
    removeImage: "移除图片",
    cancel: "取消",
  },

  // 模块辅助模块
  gamePlaza: "游戏广场",
  myCreations: "我的创作",
  romanceGenre: "恋爱类",
  createScriptText: "还没创作游戏呢，快去创作游戏吧",
  releaseText: "还没发布游戏呢，快去发布吧",
  unreleased: "未发布",
  released: "已发布",

  pleaseEnterGameName: "请输入游戏名称",
  typePlaceholder: "点击选择类型",
  clickChooseBackgroundMusic: "点击选择背景音乐",
  noBackgroundMusic: "无背景音乐",

  beginning: "开头",
  plotNode: "剧情节点",
  nodeId: "节点ID",
  score: "分数",
  connected: "已连接",

  plotPoint: "剧情点",
  activationCondition: "激活条件",
  copyToCurrentCanvas: "应用到当前画布",

  unnamedNode: "未命名节点",
  noImage: "无图片",
  noDialog: "暂无对话",
  noSelectedDialog: "还没有已选择的对话",

  pleaseInputDialog: "请输入对话内容",
  dialogLimitTip: "文本若超出两行或超出字符限制，超出部分在游戏中可能将被隐藏",
  lineLimit: "行数限制",
  charLimit: "字符限制",
  row: "行",

  static: {
    end: "结局",
    character: "角色",
    image: "插图",
    audio: "音频",
    word: "字数",
  },

  showUpCharacters: "出场角色：",
  viewConversation: "查看对话",
  audioManager: "音频管理",

  values: {
    // 数值设置
    title: "数值设置",
    people: "人物数值",
    other: "其他数值",
    tips: "您可在 <span class='text-primary'>演出设置</span> 中添加或删除人物，展示并添加数值后可在游戏中进行数值设置",
    show: "展示",
    add: "添加数值",
    name: "名称",
    nameTip: "数值名称",
    init: "初始值",
    initTip: "-100 ~ 100 之间的整数",
    desc: "说明",
    descTip: "数值介绍",

    // 连接节点条件语句
    condition: "条件语句",
    operation: "操作符",
    and: "且",
    or: "或",
    greater: "大于",
    less: "小于",
    greaterEqual: "大于等于",
    lessEqual: "小于等于",
    equal: "等于",
    notEqual: "不等于",

    deleteTitle: "是否删除该数值",
    rule: {
      name: "请填写名称",
      initScore: "请填写初始值",
    },
    conditionFormatError: "条件语句格式错误",
    tip: `提示：先选择人物或游戏的数值，然后直接点击大于、小于、大于等于或小于等于操作符，最后输入数值。多个条件中间用 "且" 或者 "或" 连接。`,
    empty: "快去添加数值吧",
  },

  fromStory: "从故事中导入",
  fromText: "从文本导入",
};

const Payment = {
  title: "收益",
  deposit: "充值",
  balance: "余额",
  income: "收入",
  expenditure: "支出",
  incomeRecord: "收益明细",
  myRoleIncome: "我的OC收益",
  originContent: "原内容",
  fee: "已扣除平台抽佣：${platformFeeAmount}",
  type: {
    tip: "贡献了",
    admireSubscriptionFee: "贡献了",
    mediaOrder: "贡献了",
  },
  leaveMessage: "并留言",

  bindPaypal: "绑定Paypal账户",

  inputPaypalAccount: "请输入 Paypal 账户",
  confirmPaypalAccount: "再次确认 Paypal 账户",
  notHasPaypal: `没有 Paypal 账户？去 <a class="text-primary" href="https://www.paypal.com/c2/welcome/signup/#/mobile_conf" target="_blank">注册</a>`,
  accountNotMatch: "两次输入的账户不一致",

  withdraw: "收款",
  withdrawRecord: "收款记录",
  tips: "提交请求后，预计 1-3 个小时到达您的 Paypal 账户",
  withdrawing: "收款中",
  withdrawStatus: {
    1: "收款中",
    2: "收款成功",
    3: "收款失败",
  },

  currentAccountBalance: "当前帐户余额",
  useableBalance: "可用余额",
  freeze: "冻结金额",
  freezeTip:
    "结算金额为上个月的收益，本月15号前的收益会进入冻结账户。在本月16日会自动解冻。",
  nextAutoPayTime: "下次自动付款时间",
  payTip:
    "注意：每次通过 Paypal 付款，均会产生 $0.25~20 不等的单笔转账手续费（视您的paypal账户所在地而定）。因此建议，调高最低自动收款金额，减少手续费。",
  settingMinAmount: "设置您的最小自动收款金额",
  minAutoWithdrawal: "最低自动收款金额",
  autoTip:
    "若本期可用余额大于最低自动收款金额，将会在下次自动付款时间，把所有可用余额全额结清。否则将会累积到下个月结算。",
  nextAutoWithdrawAmount: "下次自动收款金额",
  containPaypalFee: "（Paypal 手续费：${amount}）",

  withdrawToPaypal: "收款到 Paypal 账户",
  replaceBind: "更换绑定",
  withdrawAmountEmpty: "请输入收款金额",
  withdrawAmountMin: "收款金额需大于 1",
  withdrawAmountNotEnough: "收款金额不足",

  recent: {
    day: "最近3天",
    week: "最近一周",
    month: "最近一个月",
  },

  success: "支付成功",
  subscribed: "恭喜您，成功订阅<b class='text-primary'>{type}</b>版",
  paymentChecking: "正在检查支付结果...",

  chatList: "聊天列表",
  unlockImage: "解锁图片",
  expiredAt: "订阅到期时间",
};

const ReloadPrompt = {
  offline: "App离线使用已就绪",
  hasUpdate: "发现新版本，现在更新吗？",
  reload: "更新",
  later: "稍后",
};

const Home = {
  home: "首页",
  interactive: "互动",
  discover: "发现",
  mine: "我的",
  createNew: "立刻创建一个属于你的 OC 吧！",
  advanced: "进阶创作",
  ocCreator: "OC 编辑器",
  original: "原创角色",
  fanswork: "二创角色",
  advancedCreate: "进阶创作",
  currentIdentity: "当前身份",
  game: "视觉小说",
  hot: "热门",
  hotImage: "热门图片",
  hotReplacement: "使用更换人物的热门作品",
  latest: "最新",
  storyVideo: "故事视频",
  like: "你也许会喜欢",
  type: {
    1: "角色",
    2: "饼友圈",
    3: "故事",
    4: "视觉小说",
    Original: "原创角色",
    Fanswork: "二创角色",
  },
  more: {
    character: "更多角色",
    game: "更多游戏",
    story: "更多故事",
  },
  menu: {
    edit: "OC工坊",
    chat: "OC互动",
    painting: "绘画",
  },

  OC: {
    residentCount: "伙伴：{count} 人",
    runtime: "已运转：{runtime}",
    wordCount: "字数：{wordCount}",
    mediaCount: "稿件数量：{mediaCount}",
    momentCount: "随记数量：{momentCount}",
    storyCount: "故事数量：{storyCount}",
    thingsCount: "物品数量：{thingsCount}",
    taskCount: "任务数量：{taskCount}",
    OCResident: "在{name}的伙伴",
    noMates: "暂无伙伴",
    addMate: "+伙伴",
    addMateFromCurrentWorldview: "将现有OC添加到当前星球",
    addMateFromNew: "创建新OC",
  },
  planet: {
    timeline: "{name}编年史",
  },
};

const Animation = {
  inert: "插入动画",
  name: "名称",
  keyframe: "关键帧",
  preview: "动画预览",
  verticalPainting: "立绘",
  notSet: "未设置",
  list: "动画列表",
  creation: "动画创作",
  blink: "眨眼动画",
  lipSync: "口型动画 (开发中...)",
  btn: {
    create: "创作动画",
  },

  type: {
    blink: "眨眼",
    lipSync: "口型",
  },
  portraitType: {
    openEyes: "睁眼",
    closeEyes: "闭眼",
    openMouth: "张嘴",
    closeMouth: "闭嘴",
    halfOpenMouth: "半张嘴",
  },
};

const Config = {
  seconds: "秒",
};

const Coin = {
  coin: "硬币",
  getCoin: "获取硬币",
  goGetRecordsView: "获取记录",
  dailyTask: "每日任务",
  oneTimeTask: "一次性任务",
  residentTask: "常驻任务",
  reward: "奖励",
  community: "社区活动",
  dailyTaskLimit: "今日获取硬币上限",
  dailyCheck: "签到",
  dailyChecked: "今日已签到",
  postReactionTask: "对任意内容进行表情交互",
  reviewTask: "评论不同作品并获得作者不少于10个字的回复",
  moreTask: "更多任务",
  bioTask: "完善一个角色的简介（最少33个字）",
  updateAvatarTask: "更新一个角色的头像",
  coinUsageIntroTitle: "硬币有什么用途?",
  goldTicketIntroTitle: "金票有什么用途?",
  coinUsageIntroDesc:
    "硬币是在饼次元社区中获取，可用于购买推荐票。推荐票可在月榜活动中为你喜欢的内容进行投票。",
  getCoinIntroTitle: "获取硬币的方式有哪些？",
  getCoinIntroDesc:
    "用户可通过在社区每日活跃、购买付费内容、打赏，或者参与其他社区活动获得硬币",
  checking: "正在签到...",
  coinRecords: "明细查询",
  incomeRecord: "获取记录",
  incomeRecordEmpty: "暂无获取记录",
  expenditureRecord: "消费记录",
  expenditureRecordEmpty: "暂无消费记录",
  voted: "已投票",
  buyTicket: "购买推荐票",

  voteIncentive: "投票激励",
  ticket: "票",
  noEnoughCoin: "硬币不足",
  insufficientGoldTickets: "金票不足",
  ticketNum: "票数",
  goldTicketNum: "金票数",
  inputTicketNum: "请输入票数",
  leaveMessage: "留言",
  consumptionCoins: "本次消耗",
  restCoins: "当前剩余硬币",
  restGoldTicket: "当前剩余金票",
  buyTicketsAndVote: "兑换并投票",
  howManyTicketsToVote:
    '你想为 <span class="text-base-content">{name}</span> 投几票？',
  donate: "打赏激励",
  howMuchMoneyToDonate:
    '你想打赏激励 <span class="text-base-content font-bold">{name}</span> 多少水晶？',
  amount: "金额",
  inputAmount: "请输入金额",
  anonymousVote: "匿名投票",
  anonymousUser: "匿名用户",
  voteRecords: "投票明细",
  anonymousVoteLimit: "匿名投票需要写10字以上留言",
  todayRestVotingCount: "今日剩余可兑换票数",
  overTodayRestVotingCount: "超出今日可兑换票数",
  vote: "投票",
  goldTicket: "金票",
  regularTicket: "普通票",
  getGoldTicket: "获取金票",
  goldTicketRules: goldTicketRules,
  goldTicketVoteLimit: "使用金票需要写200字以上留言",

  identity: "身份",
  seniorReader: "资深读者",
  regularReader: "普通读者",
  applySeniorReader: "申请成为资深读者",
  reasonForApplication: "申请理由",
  bodyOfText: "正文",
  seniorReaderRules: seniorReaderRules,
  applicationSubmitted:
    "您的申请已经提交，我们将通过邮件和站内通知告知您审核结果",
  applicationApproved: "恭喜您，您的申请已经通过",

  give: "完成投票您可获得",
};

const rank = {
  ranking: "排名",
  rank: "排行",
  mostPopularRank: "最受欢迎排行榜",
  updateTime: "最近更新",
  firstHalf: "上",
  secondHalf: "下",
  noWorkOnRank: "暂无{name}上榜",
  noWorkOnRankDesc: "为{name}投票，让你喜欢的{name}上榜",
  noMateOnRank: "暂无角色上榜",
  noMateOnRankDesc: "为角色投票，让你喜欢的角色上榜",
  noGameOnRank: "暂无游戏上榜",
  noGameOnRankDesc: "为游戏投票，让你喜欢的游戏上榜",
  noStoryOnRank: "暂无故事上榜",
  noStoryOnRankDesc: "为故事投票，让你喜欢的故事上榜",
  comments: "评论区",
  rankOfCurrentMonth: "本月排行",
  notRanked: "未上榜",
  contentHome: "作品首页",
  mateHome: "角色首页",
  getVotesCount: "票数",
  pastRankings: "往期排行",
  historyLeaderboard: "历史榜单",
  currentLeaderboard: "本月榜单",
  overallLeaderboard: "总榜",
  rules: "规则说明",
  leaderboardRulesExplanation: "排行榜规则说明",
  rankRulesContent: rankRules,
  onGoing: "进行中",
  concluded: "已结束",
};

const collection = {
  name: "合集",
  window: "橱窗",
  no: "暂无可见合集",
  my: "我的合集",
  title: "标题",
  titleDesc: "合集标题",
  summer: "简介",
  summerDesc: "合集简介",
  inviteCreator: "邀请共创者",
  addCreator: "添加我的OC",
  know: "了解共创合集",
  join: "加入合集",
  select: "选择合集",
  create: "创作合集",
  edit: "编辑合集",
  none: "不选择合集",

  cover: "合集封面",
  isPublic: "是否公开",

  visibility: {
    1: "公开合集",
    2: "私密合集",
  },

  addContent: "添加内容",
  addMoment: "添加随记",
  addStory: "添加故事",
  addGame: "添加游戏",
  author: "参与OC",
  count: "{momentCount}条随记 {storyCount}个故事",

  all: "全部",
  moment: "随记",
  storyBook: "故事",
  galGame: "视觉小说",

  deleteParticipant: "删除共创者",
  deleteParticipantDesc: "确认删除该共创者吗？",
  feedback: "反馈（{count}）",
  collectionTime: "收藏时间：",
  c_pTime: "收藏 & 发布时间:",
  publishTime: "发布时间：",
  collectionAsc: "收藏最早",
  collectionDesc: "收藏最晚",
  authorSort: "作者排序",
  publishAsc: "发布最早",
  publishDesc: "发布最晚",

  mode: {
    edit: "编辑模式",
    view: "查看模式",
  },

  resetOrder: "重置顺序为发布最晚",
};

const share = {
  name: "分享",
  title: "立即分享给好友",
  moment: "饼友圈",
  copyLink: "复制链接",
  shareProfile: "分享个人主页",
  shareWithLink: "通过链接分享",
};

const contactUs = {
  contactUs: "联系我们",
  needHelp: "遇到问题或寻求帮助？",
  joinCommunity: "加入用户社区",
  emailUs: "通过邮件联系我们",
  deleteAccountInstruction: `如果您想要注销账户：
            <ol>
              <li>您需要先登录自己的饼次元账户</li>
              <li>进入<a href="/mate/mine" target="_blank">角色主页</a></li>
              <li>点击角色编辑 <span class="iconify mingcute--edit-3-line" />按钮</li>
              <li>在侧边栏点击可见性</li>
              <li>点击删除账户</li>
            </ol>
            根据提示操作即可完成账户删除操作`,
};

const nsfw = {
  contentRating: "内容评级",
  nsfw: "限制级",
  sfw: "非限制级",
  noLimit: "不限制内容评级",
  isNsfw: "这是限制级内容",
  age: {
    title: "年龄验证",
    content:
      "以下内容包含限制年龄的信息，包括裸露和明确的性行为描绘。进入前，您确认您至少年满18岁或在您所在的法域中达到法定年龄，并同意查看性别相关内容。",
    enter: "我已满18岁 - 进入",
    exit: "我未满18岁 - 退出",

    welcome: "欢迎来到饼次元！",
    rules: "规则：",
    rules1: "禁止仇恨言论",
    rules2: "禁止性虐待未成年人",
    rules3: "禁止乱伦内容",
    oldThan18: "我已满18岁",
    enterAnymate: "进入饼次元",
  },

  img: {
    title: "敏感内容",
    content: "此内容可能对某些用户敏感。您必须年满18岁或以上才能查看此内容。",
    view: "查看",
    unlock: "解锁整张图片",
  },

  cnBan:
    "由于中国大陆地区相关法律法规，暂不支持中国大陆地区或中文用户查看此内容。",
  ageBan: "由于您未满18岁，暂不支持您查看此内容。",
  iosBan: "由于iOS系统限制，暂不支持iOS用户查看此内容。",

  cnPayBan:
    "由于中国大陆地区相关法律法规，暂不支持中国大陆地区或中文用户购买此内容。",
  sensitiveContent: "敏感内容",
  sensitiveContentDesc:
    "此内容可能包含敏感信息，您需要先进行登录并进行年龄验证才能查看。",
};

const purchase = {
  name: "购买",
  get: "获得物品",
  crystal: {
    notEnough: "抱歉，您没有足够的水晶",
    notEnough2: "抱歉，您没有足够的水晶，请先购买。",
    buy: "购买水晶",
    buyMore: "购买更多",
    current: "当前水晶",
    tips: "水晶可用于购买或生成无限内容",
    name: "水晶",
    confirm: "确认您的请求",
    matePrompt: "伴侣提示",
    amount: "生成数量",
    autoAddTag: "自动添加限制级标签以生成",
    cost: "花费",
    try: "免费试试",
    exchange: "可兑换{amount}",
  },

  swap: {
    powerConfirm: `确定用 {crystal} 个水晶兑换 {power} 个能量块吗？`,
    energyBoxConfirm: `确定用 {power} 个能量块兑换 {rarity}的宝箱吗？`,
  },

  power: {
    current: "当前能量块",
    name: "能量块",
    notEnough2: "抱歉，您没有足够的能量块，请先购买。",
    content: "当使用生成图片和与伴侣聊天的功能时，将消耗能量块",
    notEnough: "抱歉，您没有足够的能量块",
    buy: "兑换能量块",
    otherWaysToObtain: "其他获取方式",
    getPower: "领取能量块",
    watchVideo: "看视(guang)频(gao)",
    goToComplete: "去完成",
    finishedRewardVideoTask: "完成视频观看任务!",
    rewardVideoTaskDesc: "恭喜您已获得2",
  },

  premium: {
    title: "高级内容",
    content: `此内容需要成为伴侣的高级订阅者才能查看`,
    view: "查看",
  },

  miss: {
    name: "当前还缺少",
    crystal: "推荐充值 ¥{amount} 来购买此商品，您将获得",
    power: `您可以使用 {crystal} 水晶来兑换 {power} 个能量块 `,
    other: "其他金额",
  },

  chineseBan:
    "由于中国大陆地区相关法律法规，暂不支持中国大陆地区或中文用户购买水晶。",
  setting: {
    paid: "付费设置",
    free: "免费",
    oneTime: "付费可解锁",
    min: "最低付费费用为{amount}",
    premium: "高级订阅后可解锁",
    freeToView: "免费可看",
    oneTimeToView: "付费 {amount} 水晶可看",
    premiumToView: "高级订阅可看",
    oneTimeOrPremium: "单次付费 ${amount} 或高级订阅可看",
  },

  item: {
    unlock: "该资源尚未解锁",
    unlockDesc: "您可以通过以下方式解锁该资源",
    pay: "单独购买",
    sub: "高级订阅",
    subscription: "高级订阅解锁更多资源",
    chat: "聊天解锁",
  },

  sub: {
    subscribe: "订阅",
    title: "订阅",
    desc: `请确保您已注册与 饼次元 使用的电子邮件帐户相匹配。如果您有任何问题，请`,
    monthly: "每月",
    annually: "每年",
    current: "当前计划",
    month: "月",
    year: "年",
    payByMonth: "按月支付",
    payByYear: "按年支付",
    save: "节省",
    subscribed: "已订阅",
    subscribedTip:
      "每个订阅之间都相互独立计时和计费，会在续费的时候获得相应的水晶，如果只想保留一个订阅，请在管理页面手动关闭。",
    add: "增加订阅",
    tryFree: "免费试用",
    trial: "体验",
    free3days: "3 天",
    change: "更改订阅",
    canceling: "取消订阅中",
    cancelSuccess: "取消订阅成功",
    cancelFail: "取消订阅失败",
    popular: "最热门",
    active: "生效中",
    expireDate: "将于 {date} 自动取消",
    1: {
      title: "免费",
      profits: ["4K记忆", "创作自定义角色", "访问社区角色", "多语言翻译"],
      ban: ["聊天语音消息", "14天不活跃后删除记忆", "更改关系"],
    },
    2: {
      title: "初级",
      priceMonth: "7.99",
      priceMonthYearly: "6.79",
      profits: [
        "免费计划的所有功能",
        "每月60颗水晶（价值$10）",
        "最多16K记忆",
        "聊天“继续”功能",
        "聊天语音消息",
        "无需水晶更改记忆",
      ],
      ban: ["指定场景聊天", "指定角色关系"],
    },
    3: {
      title: "高级",
      priceMonth: "17.99",
      priceMonthYearly: "15.29",
      profits: [
        "标准计划的所有功能",
        "每月200颗水晶（价值$34）",
        "最多32K内存",
        "聊天选项式回复",
        "指定场景聊天",
        "指定角色关系",
        "自定义角色关系",
      ],
    },
    4: {
      title: "豪华",
      priceMonth: "49.99",
      priceMonthYearly: "42.49",
      profits: [
        "高级计划的所有功能",
        "每月700颗水晶（价值$119）",
        "最多64K内存",
      ],
      star: ["私人 Discord 频道", "新功能提前访问", "专属头像框"],
    },
  },
};

const translate = {
  selectTranslateLanguage: "选择翻译语言",
  lang: {
    Albanian: "阿尔巴尼亚语",
    Amharic: "阿姆哈拉语",
    Arabic: "阿拉伯语",
    Armenian: "亚美尼亚语",
    Bengali: "孟加拉语",
    Bosnian: "波斯尼亚语",
    Bulgarian: "保加利亚语",
    Burmese: "缅甸语",
    Catalan: "加泰罗尼亚语",
    Chinese: "中文",
    Croatian: "克罗地亚语",
    Czech: "捷克语",
    Danish: "丹麦语",
    Dutch: "荷兰语",
    English: "英语",
    Estonian: "爱沙尼亚语",
    Finnish: "芬兰语",
    French: "法语",
    Georgian: "格鲁吉亚语",
    German: "德语",
    Greek: "希腊语",
    Gujarati: "古吉拉特语",
    Hindi: "印地语",
    Hungarian: "匈牙利语",
    Icelandic: "冰岛语",
    Indonesian: "印度尼西亚语",
    Italian: "意大利语",
    Japanese: "日语",
    Kannada: "卡纳达语",
    Kazakh: "哈萨克语",
    Korean: "韩语",
    Latvian: "拉脱维亚语",
    Lithuanian: "立陶宛语",
    Macedonian: "马其顿语",
    Malay: "马来语",
    Malayalam: "马拉雅拉姆语",
    Marathi: "马拉地语",
    Mongolian: "蒙古语",
    Norwegian: "挪威语",
    Persian: "波斯语",
    Polish: "波兰语",
    Portuguese: "葡萄牙语",
    Punjabi: "旁遮普语",
    Romanian: "罗马尼亚语",
    Russian: "俄语",
    Serbian: "塞尔维亚语",
    Slovak: "斯洛伐克语",
    Slovenian: "斯洛文尼亚语",
    Somali: "索马里语",
    Spanish: "西班牙语",
    Swahili: "斯瓦希里语",
    Swedish: "瑞典语",
    Tagalog: "他加禄语",
    Tamil: "泰米尔语",
    Telugu: "泰卢固语",
    Thai: "泰语",
    Turkish: "土耳其语",
    Ukrainian: "乌克兰语",
    Urdu: "乌尔都语",
    Vietnamese: "越南语",
  },
};

const About = {
  policies: "政策",
  privacyPolicy: "隐私政策",
  termsOfService: "服务条款",
  communityGuidelines: "社区指南",
  contentRemovalPolicy: "内容移除政策",
  ComplaintsPolicy: "投诉政策",
  policyAnnounce: "我们不会向第三方出售您的个人信息。继续使用，您将同意我们的",
};

const helper = {
  earn: {
    title: "如何赚取收入",
    0: "编辑您的角色的信息和聊天提示",
    1: "其他用户支付水晶来解锁您的角色发送的消息",
    2: "它将自动将水晶转换为现金并转入您的账户",
  },
};

const Dungeons = {
  title: "我的OC",
  createMate: "创建OC",
  createPlanet: "星球",
  ongoing: "正在进行的演出",
  browse: "查看全部演出",
  nav: {
    feature: "OC工坊",
    drawing: "绘梦空间",
    story: "星辰日志",
    play: "幻境剧场",
    ai: "灵魂对话",
    galgame: "剧本工坊",
  },
  statusTitle: {
    1: "招募中",
    2: "等待开始的演出",
    3: "正在进行的演出",
  },
  countDown: "{time} 分钟后开始",
  participants: "参与者",
  watching: "围观",
  room: "房间",
  createRoom: "发起演出",
  noDungeons: "您还没有参与任何演出。",
  registered: "已注册",
  recruited: "已招募",
  homeowner: "房主",
  loginFirst: "请先登录后再查看OC小屋哦！",

  trial: "试用",
  enroll: "报名",
  status: {
    1: "招募中",
    2: "待开始",
    3: "进行中",
    4: "已结束",
  },
  create: {
    name: "房间名称",
    scene: "场景",
    maxMate: "最大人数",
    duration: "持续时间",
    mode: "模式",
    modeOption: {
      1: "积分排名",
    },
    shortDefinition: "简短描述",
    startDate: "开始日期",
    startTime: "开始时间",
    startModeDesc: "当人数不满足游戏场景的最低要求时。",
    startModeOption: {
      1: "开始时间延迟到24小时后。",
      2: "依然开始游戏",
      3: "取消游戏",
    },
    paymentModeDesc: "当人数不满足游戏场景的最低要求时。",
    paymentModeOption: {
      1: "整个房间：你支付设置房间的所有费用，其他参与者可以免费加入。",
      2: "分摊费用：你只需支付自己的房间费用，其他人需要支付各自的费用。",
    },
    rules: {
      name: "请输入房间名称",
      scene: "请选择场景",
      maxMate: "请选择最大人数",
      duration: "请选择持续时间",
      shortDefinition: "您想对参与者说些什么",
    },
  },

  sprite: {
    name: "名称",
    mode: "模式",
    create: "创作演出动作",
    preview: "演出动作预览",
    createSpriteTips: "你还没有创作演出所需的OC人物动画",
    createSpriteTips2: "点击创建您的第一个演出动作",
    modeOption: {
      1: "提示词",
      2: "图片",
      3: "特征",
    },
    idle: "待机状态",
    running: "跑步状态",
    rules: {
      name: "请输入演出动作名称",
      mode: "请选择模式",
      prompt: "请输入提示词",
      image: "请选择图片",
      mateTrait: "请选择角色特征",
    },
    success: "演出动作保存成功",
    fail: "演出动作保存失败",

    status: {
      generating: "生成中...",
      generate: "生成",
      regenerate: "重新生成",
    },

    pleaseSelectMate: "请选择角色",
    pleaseSelectSprite: "请选择演出动作",

    confirmSprite: "确认使用 {name} 加入演出？",

    direction: {
      [MateSpriteDirection.Up]: "向上行走",
      [MateSpriteDirection.Down]: "向下行走",
      [MateSpriteDirection.Left]: "向左行走",
      [MateSpriteDirection.Right]: "向右行走",
    },
  },

  detail: {
    host: "房主",
    says: "说：",
    guide:
      "游戏指南：禁止与色情、赌博和毒品相关的话题，以及政治讨论。除此之外，没有限制。祝游戏愉快！",
    join: "加入中...",
    scene: "场景：",
    mode: "模式：",
    duration: "持续时间：",
    minutes: "分钟",
    scoreRanking: "积分排名",
    start: "开始：",
    end: "结束：",
    remaining: "本场次剩余名额：",
    createTrial: "创作试用中...",
    enrollSuccess: "恭喜您成功报名参加！",
    needMorePlayers: "大约还剩 {time}，只需要再 {count} 名玩家就可以开始游戏。",
    npc: "NPC",
    loginToEnroll: "登录报名",
  },

  discovery: {
    title: "校园时光",
    description: "让我们看看谁能通过期末考试，并赢得两位女神的芳心。",
  },

  scene: {
    "School Days": "校园时光",
  },
};

const Time = {
  day: "天",
  hour: "小时",
  minute: "分钟",
  second: "秒",
};

const HEAD = {
  title: "饼次元",
  desc: "超有爱的OC创作社区",
};

const homeGreeting = {
  "5<30": {
    title: "早上好, {name}",
    desc: "新的一天开始了，有什么关于你的OC的灵感吗？",
  },
  "5>=30": {
    title: `晨光熹微，{name}`,
    desc: "记录下你刚刚梦到的OC创意吧",
  },
  "6<30": {
    title: `早上好，{name}`,
    desc: "清晨的思绪最为清晰，为你的OC添加些新想法？",
  },
  "6>=30": {
    title: `日出东方，{name}`,
    desc: "今天想为你的OC规划些什么呢？",
  },
  "7<30": {
    title: `早安，{name}`,
    desc: "用一杯咖啡和一个灵感开始新的一天吧",
  },
  "7>=30": {
    title: `早安，{name}`,
    desc: "新的一天开始了，有什么关于你的OC的灵感吗？",
  },
  "8<30": {
    title: `晨光熹微，{name}`,
    desc: "记录下你刚刚梦到的OC创意吧",
  },
  "8>=30": {
    title: `早上好，{name}`,
    desc: "清晨的思绪最为清晰，为你的OC添加些新想法？",
  },
  "9<30": {
    title: `上午好，{name}`,
    desc: "阳光正好，有什么关于你的OC的新构思吗？",
  },
  "9>=30": {
    title: `阳光正好，{name}`,
    desc: "今天你的OC想尝试什么新事物呢？",
  },
  "10<30": {
    title: `上午时光，{name}`,
    desc: "记录下你对OC世界的新发现吧",
  },
  "10>=30": {
    title: `活力满满的上午，{name}`,
    desc: "为你的OC添加些什么特质呢？",
  },
  "11<30": {
    title: `嗨，{name}`,
    desc: "上午的灵感来敲门了，记录下你对OC的新想法吧",
  },
  "11>=30": {
    title: `上午好，{name}`,
    desc: "阳光正好，有什么关于你的OC的新构思吗？",
  },
  "12<30": {
    title: `中午好，{name}`,
    desc: "午休时刻，有什么关于你的OC的新灵感吗？",
  },
  "12>=30": {
    title: `阳光正烈，{name}`,
    desc: "午间休息，记录一下你的OC新故事吧",
  },
  "13<30": {
    title: `午时已到，{name}`,
    desc: "你的OC今天过得怎么样？",
  },
  "13>=30": {
    title: `中午好，{name}`,
    desc: "稍作休息，为你的OC勾勒新的冒险吧",
  },
  "14<30": {
    title: `午间小憩，{name}`,
    desc: "有什么关于你的OC的突发奇想吗？",
  },
  "14>=30": {
    title: `下午好，{name}`,
    desc: "下午茶时间，有什么关于你的OC的新点子吗？",
  },
  "15<30": {
    title: `午后时光，{name}`,
    desc: "今天的创作进展如何？记录一下你对OC的新想法吧",
  },
  "15>=30": {
    title: `下午好，{name}`,
    desc: "阳光渐斜，你的OC有什么新故事想讲吗？",
  },
  "16<30": {
    title: `悠闲的下午，{name}`,
    desc: "为你的OC描绘一下新场景吧",
  },
  "16>=30": {
    title: `下午时分，{name}`,
    desc: "灵感来袭了吗？记录下你对OC的新构思吧",
  },
  "17<30": {
    title: `下午好，{name}`,
    desc: "下午茶时间，有什么关于你的OC的新点子吗？",
  },
  "17>=30": {
    title: `午后时光，{name}`,
    desc: "今天的创作进展如何？记录一下你对OC的新想法吧",
  },
  "18<30": {
    title: `傍晚好，{name}`,
    desc: "夕阳西下，有什么关于你的OC的新思路吗？",
  },
  "18>=30": {
    title: `黄昏时刻，{name}`,
    desc: "一天即将结束，记录下你今天对OC的感悟吧",
  },
  "19<30": {
    title: `傍晚时分，{name}`,
    desc: "余晖中，你的OC会做什么呢？",
  },
  "19>=30": {
    title: `日落西山，{name}`,
    desc: "为你的OC记录下今天的故事吧",
  },
  "20<30": {
    title: `黄昏已至，{name}`,
    desc: "在这安静的时刻，为你的OC构思些什么呢？",
  },
  "20>=30": {
    title: `晚上好，{name}`,
    desc: "今天有什么关于你的OC的想法呢？",
  },
  "21<30": {
    title: `夜幕降临，{name}`,
    desc: "夜晚是创意迸发的时刻，记录下你对OC的新灵感吧",
  },
  "21>=30": {
    title: `良宵美景，{name}`,
    desc: "你的OC在这样的夜晚会做什么呢？",
  },
  "22<30": {
    title: `繁星点点，{name}`,
    desc: "为你的OC编织一个夜晚的故事吧",
  },
  "22>=30": {
    title: `晚风轻拂，{name}`,
    desc: "记录下你对OC的新奇想法吧",
  },
  "23<30": {
    title: `夜深了，{name}`,
    desc: "深夜的灵感总是特别丰富，记录下你对OC的奇思妙想吧",
  },
  "23>=30": {
    title: `星空璀璨，{name}`,
    desc: "有什么关于你的OC的新故事吗？",
  },
  "0<30": {
    title: `静谧的夜，{name}`,
    desc: "此刻你的OC在做什么呢？记录下来吧",
  },
  "0>=30": {
    title: `月光如水，{name}`,
    desc: "夜深人静，为你的OC描绘一个梦境吧",
  },
  "1<30": {
    title: `深夜时分，{name}`,
    desc: "无人打扰的时光最适合创作，记录下你对OC的新构思吧",
  },
  "1>=30": {
    title: `夜深了，{name}`,
    desc: "深夜的灵感总是特别丰富，记录下你对OC的奇思妙想吧",
  },
  "2<30": {
    title: `星空璀璨，{name}`,
    desc: "有什么关于你的OC的新故事吗？",
  },
  "2>=30": {
    title: `静谧的夜，{name}`,
    desc: "此刻你的OC在做什么呢？记录下来吧",
  },
  "3<30": {
    title: `月光如水，{name}`,
    desc: "夜深人静，为你的OC描绘一个梦境吧",
  },
  "3>=30": {
    title: `深夜时分，{name}`,
    desc: "无人打扰的时光最适合创作，记录下你对OC的新构思吧",
  },
  "4<30": {
    title: `夜深了，{name}`,
    desc: "深夜的灵感总是特别丰富，记录下你对OC的奇思妙想吧",
  },
  "4>=30": {
    title: `星空璀璨，{name}`,
    desc: "有什么关于你的OC的新故事吗？",
  },
  default: {
    title: `你好，{name}`,
    desc: "有什么关于你的OC的新灵感吗？",
  },
};

const invitation = {
  title: "邀请好友",
  generateInviteCode: "生成邀请码",
  generatedInviteCode: "已生成的邀请码",
  empty: {
    title: "暂无邀请码",
    desc: "快去生成邀请码吧",
  },
  cannotInviteUser: {
    title: "暂无邀请资格",
    desc: "请过段时间再来吧",
  },
  used: "已使用",
  restCount: "剩余{count}",

  inviteYou: "邀请你加入我的饼友圈！",
};

const mateModule = {
  from: "来源",
  mate: {
    label: "OC设定",
    visibility: "角色可见性",
    delete: "删除角色",
  },
  worldview: {
    title: "星球",
    label: "星球设定",
    visibility: "星球可见性",
    delete: "删除星球",
    basicInfo: {
      name: "名称",
      description: "世界观描述",
      media: "进入星球编辑器",
      mediaTips: "进入星球编辑器，为你的星球添加封面图",
      rules: {
        name: "请输入名称",
      },
    },
  },
  timeline: {
    sort: "排序id",
    default: "默认宇宙",
    empty: "还没有添加时间线哦",
    time: "事件时间",
    content: "事件内容",
    order: "排序ID",
    mate: "OC",
    moment: "随记",
    storyBook: "故事",
    detail: "详情",
    ocCard: "人物卡",

    updateDesc: "最后更新",
    timeAsc: "时间顺序",
    timeDesc: "时间倒序",
  },

  generateType: {
    roleplay: "回答",
    module: "灵感",
    mateMail: "信件",
    reply: "回复",
    moment: "随记",
  },

  generateTypeButton: {
    roleplay: "OC写",
    module: "找灵感",
    mateMail: "OC写",
    reply: "OC写",
    moment: "OC写",
  },

  treehole: {
    connectDays: "连接天数",
    connect: "连接",
    disconnect: "解除连接",
    connectTips: "连接后，将会响应我在树洞发布的所有内容",
  },
};

const mission = {
  title: "外派",
  dispatchType: "外派类型",
  dispatchTypeMap: {
    1: "溜达",
    2: "任务",
  },
  cardType: "任务类型卡",
  cardTypeCount: "( {count} 个)",
  nav: {
    journey: "OC外派手帐",
    storage: "OC物品储物间",
  },

  type: "任务类型",
  selectType: "选择任务类型",
  address: "地点",
  duration: "时长",
  dispatchDuration: "外派时长",
  gain: "任务奖励",
  expectedGain: "{count} 篇手帐, {countEquipment} 个物品",
  expectedGainStroll: "{count}篇手帐，结识1个OC",
  exec: "派遣",
  inviteFriend: "邀请",
  target: "任务目标",

  inviteTask: "邀请任务",

  statusMap: {
    "-1": "全部",
    1: "休息中",
    2: "外派中",
    3: "待迎接",
    4: "溜达中",
    5: "准备中",
    6: "准备中",
  },
  dispatchRequestStatusMap: {
    all: "全部",
    [MateDispatchStatusRequest.Preparing]: "准备中",
    [MateDispatchStatusRequest.Dispatched]: "外派中",
    [MateDispatchStatusRequest.Returned]: "待迎接",
    [MateDispatchStatusRequest.Settled]: "已完成",
    [MateDispatchStatusRequest.Canceled]: "已取消",
  },
  dispatchStatusMap: {
    "-1": "全部",
    6: "准备中",
    1: "外派中",
    2: "外派中",
    3: "待迎接",
    4: "已完成",
    7: "准备中",
    8: "已取消",
    5: "已取消",
  },
  statusBtnMap: {
    1: "外派",
    2: "▶▶加速",
    3: "去迎接",
    4: "溜达中",
    5: "准备中",
    countDown: "{minute}分钟{second}秒后回归",
  },

  suitableTrait: "适合OC特质",
  reward: "奖励",
  risk: "风险",

  location: {
    title: "派遣位置",
    select: "选择地点",
    new: "新建地点",
    newTitle: "在{name}中新建地点",
    placeholder: {
      name: "请输入地点名称",
      description: "请输入地点描述",
    },
    no: "暂无地点",
    selectFirst: "请先选择派遣地点",
  },

  mission: {
    selectFirst: "请先选择任务类型",
  },

  mate: {
    leader: "领队",
    follow: "随行",
    addFollow: "+随行OC",
    addLeader: "+领队",
    select: "选择随行OC",
    selectFirst: "请先选择领队OC",
    no: "暂无OC",
  },

  carryItems: {
    title: "携带物品",
    maxTips: "最多携带{count}个物品",
    addBtn: "+新增",

    selectJournal: "选择手帐",
    selectMail: "选择信件",
    selectMoment: "选择随记",
    selectDispatch: "选择任务",
    selectMemory: "选择记忆",
    selectSceneMemory: "选择场景记忆",
    selectRoleplayAnswer: "选择问答",

    select: "选择前情",
    alreadySelect: "已选前情({count})",
  },

  record: {
    title: "派遣记录",
    dispatchTime: "派遣时间",
    obtainItems: "获取物品",
    obtainJournal: "获取手帐",
  },

  journey: {
    received: "你获得 {count} 篇手帐, {countEquipment} 个物品！",
    receivedStroll: "你获得1篇手帐, 结识了以下 OC！",
    createTimeline: "创建OC时间线",
    createMoment: "创建OC随记",
    time: "外派时间",
    weather: "天气",
    createTimelineConfirmTitle: "是否创建OC时间线？",
    createTimelineConfirmDesc:
      "点击确认会将本条内容直接添加到该 OC 的时间线第一条。",
    afterCreateTimeline: "创建成功，是否前往 OC 编辑页查看？",

    createMomentConfirmTitle: "是否创建OC随记？",
    createMomentConfirmDesc:
      "点击确认会将本条内容直接添加到该 OC 的随记列表第一条。",
    afterCreateMoment: "创建成功是否前往查看？",
  },

  equipment: {
    title: "OC物品储物间",
    no: "暂无物品",
    addBtn: "+新增",
    max: "超过携带物品上限",
    my: "我的储物间",
    buy: "购买8个格子 5",
    description: "描述",
    effect: "效果",
    missionSuccessRate: "任务成功率",

    firstDiscovery: "首次发现",
    recycle: "销毁",
    recycleConfirm: "确定要销毁该装备吗？",
    recycleSuccess: "销毁成功",
    recycleFailed: "销毁失败",
    openChestSuccess: "打开成功",

    lock: "锁定",
    lockConfirm: "确定要锁定该装备吗？锁定后的装备将不会被批量销毁",
    lockSuccess: "锁定成功",
    unlock: "解锁",
    unlockConfirm: "确定要解锁该装备吗？",
    unlockSuccess: "解锁成功",

    select: "选择装备",

    rarity: {
      name: "品质",
      1: "普通",
      2: "罕见",
      3: "稀有",
      4: "史诗",
    },

    expandInventoryMessage: "确定要花费 5 水晶购买 8 个物品格吗？",
    putInBox: "存入物品箱",

    boxType: {
      [ChestType.Normal]: "能量箱",
      [ChestType.BasicMember]: "小镇规划师特供",
      [ChestType.StandardMember]: "行星构筑师特供",
      [ChestType.PremiumMember]: "星际幻想家特供",
    },
  },
  difficultyLevel: {
    [DispatchDifficultyLevel.Easy]: "简单",
    [DispatchDifficultyLevel.Medium]: "中等",
    [DispatchDifficultyLevel.Hard]: "困难",
    [DispatchDifficultyLevel.Nightmare]: "噩梦",
    [DispatchDifficultyLevel.Hell]: "地狱",
  },

  rateText: {
    lowest: "非常低",
    low: "低",
    medium: "中",
    high: "高",
    highest: "非常高",
  },
  noTarget: "暂无目标",
};

const mateWish = {
  name: "祈愿",
  status: {
    0: "全部",
    1: "等待回响",
    2: "已完成",
  },
  no: "暂无",
  lead: "主角",
  optional: "(可选)",
  waitTime: "预计回响时间: {hour}小时内",
  timeout: "即将完成...",
  view: "查看",
  return: "祈愿回响",
  viewDemo: "查看样例",
  new: "发起祈愿",
  newWithMj: "智能画师",
  newWithManual: "人类画师",
  content: "描述文字",
  contentPlaceholder: "请输入描述文字",
  referenceImagezzPlaceholder: "请选择参考图",
  select: "选择你的OC",
  whatTitle: "什么是祈愿？",
  what: `### 什么是祈愿？
1. 选择一段打动你的文字：它可以是你的随记片段、手帐、故事节选，或任何你想赋予生命的语句。
2. 选择你的参考图（可选、最多 6 张）：想让你的原创角色成为这幅画的主角吗？选择你心爱的 OC 们，它将出现在根据文字生成的插画中。
3. 生成独一无二的插画：
    - 若你选择了参考图，插画将围绕你的参考图展开，生动演绎文字中的情境。 
    - 若你未选择参考图，插画将纯粹聚焦于文字本身，为你创造一幅展现文字描绘之景或抽象意境的无角色画作。`,
  toMoment: "发随记",
  saveToGallery: "保存到 OC 的稿件",
  saveSuccessConfirmToGallery: "保存成功，是否前往查看？",

  settings: {
    style: "偏好画风",
    multipleChoice: "(可多选)",
    aspectRatio: "偏好图片比例",
  },
  reference: "参考图",
};

const characterGenerator = {
  Body: "身体",
  Head: "头部",
  Torso: "躯干",
  Arms: "手臂",
  Legs: "腿部",
  Tools: "工具",
  Weapons: "武器",
  sexes: {
    male: "男性",
    female: "女性",
    child: "儿童",
    teen: "青少年",
    pregnant: "孕妇",
    muscular: "肌肉男",
  },
  itemName: {
    Body: "身体",
    Shadow: "阴影",
    Bodies: "身体",
    Wounds: "伤口",
    Prostheses: "义肢",
    Tails: "尾巴",
    Wings: "翅膀",
    Head: "头部",
    Heads: "头部",
    Expressions: "表情",
    "Eye Color": "眼睛颜色",
    "Other Eyes": "其他眼睛",
    Ears: "耳朵",
    Nose: "鼻子",
    Eyebrows: "眉毛",
    Beards: "胡子",
    Mustaches: "胡子",
    Hair: "头发",
    Horns: "角",
    Fins: "鳍",
    Hoods: "帽子",
    "Head Covers": "头罩",
    Hats: "帽子",
    Helmets: "头盔",
    Visors: "面具",
    Accessories: "饰品",
    "Facial Accessories": "面部饰品",
    Glasses: "眼镜",
    Monocle: "单眼镜",
    Eyepatches: "眼罩",
    Mask: "面具",
    Earrings: "耳环",
    Neck: "颈部",
    "Neck Decor": "颈部装饰",
    Necklace: "项链",
    "Necklace Charms": "项链饰品",
    Arms: "手臂",
    Shoulders: "肩膀",
    Bauldron: "水壶",
    Wrists: "手腕",
    Gloves: "手套",
    Ring: "戒指",
    Torso: "躯干",
    Dresses: "连衣裙",
    Shirts: "衬衫",
    Aprons: "围裙",
    Bandages: "绷带",
    Chainmail: "锁子甲",
    Jacket: "夹克",
    "Jacket Trim": "夹克装饰",
    Vest: "背心",
    Armour: "盔甲",
    Cape: "斗篷",
    Backpack: "背包",
    Base: "基础",
    Quiver: "箭袋",
    Waist: "腰部",
    Obi: "腰带",
    Knots: "绳子",
    Legs: "腿部",
    Pants: "裤子",
    Shoes: "鞋子",
    Socks: "袜子",
    Tools: "工具",
    Shield: "盾牌",
    Weapons: "武器",
    Swords: "剑",
    Magic: "魔法",
  },
  itemDetailName: {
    Shadow: "阴影",
    "Body color": "身体颜色",
    Zombie: "僵尸",
    Skeleton: "骷髅",
    Arm: "手臂",
    Brain: "大脑",
    Ribs: "肋骨",
    "Left Eye": "左眼",
    "Right Eye": "右眼",
    Mouth: "嘴巴",
    "Hook hand": "钩手",
    "Peg leg": "木腿",
    "Wolf Tail": "狼尾巴",
    "Fluffy Wolf Tail": "蓬松的狼尾巴",
    "Cat Tail": "猫尾巴",
    "Lizard tail": "蜥蜴尾巴",
    "Lizard Tail (Alt Colors)": "蜥蜴尾巴(其他颜色)",
    "Feathered Wings": "羽毛翅膀",
    "Bat Wings": "蝙蝠翅膀",
    "Lizard Wings (Alt Colors)": "蜥蜴翅膀(其他颜色)",
    "Monarch Wings": "君主翅膀",
    "Monarch Wings Edge": "君主翅膀边缘",
    "Monarch Wings Dots": "君主翅膀斑点",
    "Pixie Wings": "精灵翅膀",
    "Transparent Pixie Wings": "透明精灵翅膀",
    "Lunar Wings": "月亮翅膀",
    "Dragonfly Wings": "蜻蜓翅膀",
    "Transparent Dragonfly Wings": "透明蜻蜓翅膀",
    "Lizard Wings": "蜥蜴翅膀",
    "Batlike Lizard Wings": "类蝙蝠蜥蜴翅膀",
    "Human child": "人类儿童",
    "Human female": "人类女性",
    "Human male": "人类男性",
    "Human female elderly": "人类老年女性",
    "Human male elderly": "人类老年男性",
    "Human male plump": "人类胖男性",
    "Human male gaunt": "人类瘦男性",
    "Human male small": "人类矮小男性",
    "Human female small": "人类矮小女性",
    "Human elderly small": "人类矮小老人",
    Boarman: "野猪人",
    "Boarman child": "野猪人儿童",
    Pig: "猪",
    "Pig child": "小猪",
    Sheep: "羊",
    "Sheep child": "小羊",
    Minotaur: "牛头人",
    "Minotaur female": "女牛头人",
    "Minotaur child": "牛头人儿童",
    Wartotaur: "疣猪牛头人",
    "Wolf child": "小狼",
    "Wolf female": "母狼",
    "Wolf male": "公狼",
    Rabbit: "兔子",
    "Rabbit child": "小兔子",
    Rat: "老鼠",
    "Rat child": "小老鼠",
    Mouse: "鼠",
    "Mouse child": "小鼠",
    "Lizard child": "蜥蜴幼崽",
    "Lizard female": "母蜥蜴",
    "Lizard male": "公蜥蜴",
    "Orc child": "兽人儿童",
    "Orc female": "女兽人",
    "Orc male": "男兽人",
    Goblin: "哥布林",
    "Goblin child": "哥布林儿童",
    Alien: "外星人",
    Troll: "巨魔",
    "Troll child": "巨魔儿童",
    "Jack O Lantern": "南瓜灯",
    Vampire: "吸血鬼",
    Frankenstein: "科学怪人",
    Neutral: "中性",
    "Closing Eyes": "闭眼",
    "Closed Eyes": "闭着眼",
    "Looking Right": "向右看",
    "Looking Left": "向左看",
    "Rolling Eyes": "翻白眼",
    Shock: "震惊",
    Angry: "生气",
    "Angry Alt": "生气(其他)",
    Sad: "悲伤",
    "Sad Alt": "悲伤(其他)",
    Happy: "开心",
    "Happy Alt": "开心(其他)",
    Blush: "脸红",
    Shame: "羞愧",
    Tears: "眼泪",
    "Eye Color": "眼睛颜色",
    "Child Eyes": "儿童眼睛",
    "Cyclops Eyes": "独眼",
    "Big ears": "大耳朵",
    "Elven ears": "精灵耳朵",
    "Long ears": "长耳朵",
    "Medium Elven Ears": "中等精灵耳朵",
    "Hanging Elven Ears": "下垂精灵耳朵",
    "Downward Elven Ears": "向下精灵耳朵",
    "Dragon Ears": "龙耳朵",
    "Cat Ears": "猫耳朵",
    "Wolf Ears": "狼耳朵",
    "Side Wolf Ears": "侧面狼耳朵",
    "Side Cat Ears": "侧面猫耳朵",
    "Feather Ears": "羽毛耳朵",
    "Big nose": "大鼻子",
    "Button nose": "扣子鼻",
    "Straight nose": "直鼻子",
    "Elderly nose": "老年鼻子",
    "Large nose": "大鼻子",
    "Thick Eyebrows": "粗眉毛",
    "Thin Eyebrows": "细眉毛",
    "Basic Beard": "基础胡子",
    "Winter Beard": "冬季胡子",
    "5 O'clock Shadow": "胡茬",
    "Trimmed Beard": "修剪过的胡子",
    "Medium Beard": "中等胡子",
    "Big Mustache": "大胡子",
    Mustache: "胡子",
    "French Mustache": "法式胡子",
    "Walrus Mustache": "海象胡子",
    "Chevron Mustache": "V形胡子",
    "Handlebar Mustache": "车把式胡子",
    "Lampshade Mustache": "灯罩式胡子",
    "Horseshoe Mustache": "马蹄形胡子",
    Afro: "非洲式发型",
    Natural: "自然发型",
    "Dreadlocks short": "短散乱发",
    "Twists fade": "渐变扭曲发",
    "Twists straight": "直扭曲发",
    "Dreadlocks long": "长散乱发",
    "Flat top straight": "直平顶发",
    "Flat top fade": "渐变平顶发",
    Cornrows: "玉米辫",
    Jewfro: "犹太式卷发",
    "Curly short": "短卷发",
    "Curly long": "长卷发",
    Balding: "秃顶",
    Longhawk: "长莫霍克",
    Shorthawk: "短莫霍克",
    "High and tight": "高紧发型",
    Buzzcut: "寸头",
    Plain: "普通发型",
    Pixie: "精灵发型",
    Page: "齐刘海",
    Idol: "偶像发型",
    Mop: "拖把头",
    Parted: "分开发型",
    "Parted 2": "分开发型2",
    "Parted 3": "分开发型3",
    "Side Parted w/Bangs": "侧分刘海",
    "Side Parted w/Bangs 2": "侧分刘海2",
    Messy1: "凌乱1",
    Messy2: "凌乱2",
    Messy3: "凌乱3",
    Bedhead: "睡乱发",
    Unkempt: "蓬乱发",
    Bangsshort: "短刘海",
    Swoop: "侧扫发",
    "Side Swoop": "侧扫发2",
    Curtains: "帘式发型",
    Page2: "齐刘海2",
    Bangs: "刘海",
    Single: "单发",
    Cowlick: "牛舔发",
    "Cowlick tall": "高牛舔发",
    "Spiked porcupine": "刺猬头",
    "Spiked liberty2": "自由尖刺2",
    "Spiked liberty": "自由尖刺",
    "Spiked beehive": "蜂巢尖刺",
    Spiked: "尖刺发",
    Spiked2: "尖刺发2",
    Halfmessy: "半凌乱",
    Bunches: "束发",
    Pigtails: "双马尾",
    "Pigtails bangs": "刘海双马尾",
    Bob: "波波头",
    Lob: "长波波头",
    "Bob side part": "侧分波波头",
    "Relm Short": "短瑞姆发",
    "Half up": "半扎发",
    "Bangs bun": "刘海包子头",
    "Short Topknot": "短丸子头",
    "Short Topknot 2": "短丸子头2",
    "Long Topknot": "长丸子头",
    "Long Topknot 2": "长丸子头2",
    Ponytail: "马尾",
    Ponytail2: "马尾2",
    "High ponytail": "高马尾",
    Braid: "辫子",
    Braid2: "辫子2",
    Shoulderl: "左肩发",
    Shoulderr: "右肩发",
    "Long tied": "长扎发",
    "Relm w/Ponytail": "瑞姆马尾",
    Loose: "松散发",
    Bangslong: "长刘海",
    Bangslong2: "长刘海2",
    Long: "长发",
    "Long messy": "凌乱长发",
    "Long messy2": "凌乱长发2",
    "Curtains long": "长帘式",
    Wavy: "波浪发",
    "Long center part": "中分长发",
    "Long straight": "直长发",
    Princess: "公主发",
    Sara: "萨拉发",
    "Long band": "长带发",
    Xlong: "超长发",
    "XLong Wavy": "超长波浪发",
    "Left Braid": "左辫子",
    "Right Braid": "右辫子",
    "Left XLong Bang": "左超长刘海",
    "Right XLong Bang": "右超长刘海",
    "Left XLong Braid": "左超长辫子",
    "Right XLong Braid": "右超长辫子",
    "High Bun": "高包子头",
    "Backwards Horns": "后角",
    "Curled Horns": "卷角",
    Fin: "鳍",
    "Short fin": "短鳍",
    Hood: "兜帽",
    "Sack Cloth Hood": "麻布兜帽",
    Hijab: "头巾",
    Mail: "锁子甲帽",
    Bandana: "头巾",
    "Bordered Bandana": "边框头巾",
    "Pirate Bandana": "海盗头巾",
    Kerchief: "方巾",
    "Tied Headband": "系带头带",
    "Thick Headband": "厚头带",
    "Hair Tie": "发带",
    "Leather Cap": "皮帽",
    Bonnie: "邦尼帽",
    "Bonnie Alt Tilt": "倾斜邦尼帽",
    Cavalier: "骑士帽",
    Tricorne: "三角帽",
    "Tricorne Lieutenant": "中尉三角帽",
    "Tricorne Captain": "船长三角帽",
    "Bicorne Athwart": "横戴双角帽",
    "Bicorne Athwart Captain": "船长横戴双角帽",
    "Bicorne Athwart Admiral": "将军横戴双角帽",
    "Bicorne Athwart Commodore": "准将横戴双角帽",
    "Bicorne foreaft": "前后双角帽",
    "Bicorne Foreaft Commodore": "准将前后双角帽",
    "Large Hat": "大帽子",
    "Wizard Hat Base": "基础巫师帽",
    "Celestial Wizard Hat": "天界巫师帽",
    "Celestial Wizard Moon Hat": "天界月亮巫师帽",
    "Formal Tophat": "正式礼帽",
    "Formal Bowler Hat": "正式圆顶礼帽",
    Crown: "皇冠",
    Tiara: "王冠",
    "Christmas Hat": "圣诞帽",
    Armet: "盔甲头盔",
    "Simple Armet": "简单盔甲头盔",
    Barbarian: "野蛮人头盔",
    "Barbarian nasal": "野蛮人鼻甲头盔",
    "Barbarian Viking": "野蛮维京头盔",
    Barbuta: "巴布塔头盔",
    "Simple barbuta": "简单巴布塔头盔",
    Bascinet: "巴西尼特头盔",
    "Round bascinet": "圆形巴西尼特头盔",
    "Close helm": "封闭头盔",
    Flattop: "平顶头盔",
    Greathelm: "大头盔",
    "Horned helmet": "角盔",
    "Kettle helm": "锅盔",
    Legion: "军团头盔",
    Maximus: "马克西姆斯头盔",
    Morion: "莫里昂头盔",
    "Nasal helm": "鼻甲头盔",
    "Norman helm": "诺曼头盔",
    "Pointed helm": "尖顶头盔",
    Spangenhelm: "条带头盔",
    "Viking spangenhelm": "维京条带头盔",
    "Sugarloaf greathelm": "糖面包大头盔",
    "Simple sugarloaf helm": "简单糖面包头盔",
    "Xeon helmet": "氙气头盔",
    "Grated visor": "格栅面罩",
    "Narrow grated visor": "窄格栅面罩",
    "Horned visor": "角面罩",
    "Pigface visor": "猪脸面罩",
    "Pigface visor raised": "抬起的猪脸面罩",
    "Round visor": "圆形面罩",
    "Round visor raised": "抬起的圆形面罩",
    "Slit visor": "缝隙面罩",
    "Narrow slit visor": "窄缝隙面罩",
    Crest: "头冠",
    "Centurion Crest": "百夫长头冠",
    "Helmet wings": "头盔翅膀",
    "Short Horns": "短角",
    "Upward Horns": "向上角",
    "Downward Horns": "向下角",
    Plumage: "羽饰",
    "Centurion Plumage": "百夫长羽饰",
    "Legion Plumage": "军团羽饰",
    Glasses: "眼镜",
    "Halfmoon Glasses": "半月形眼镜",
    "Nerd Glasses": "书呆子眼镜",
    Shades: "墨镜",
    "Secretary Glasses": "秘书眼镜",
    "Round Glasses": "圆形眼镜",
    Sunglasses: "太阳镜",
    "Left Monocle": "左单片眼镜",
    "Right Monocle": "右单片眼镜",
    "Eyepatch Ambidextrous": "双用眼罩",
    "Eyepatch Left": "左眼罩",
    "Eyepatch Right": "右眼罩",
    "Eyepatch 2 Left": "左眼罩2",
    "Eyepatch 2 Right": "右眼罩2",
    "Small Eyepatch Left": "小左眼罩",
    "Small Eyepatch Right": "小右眼罩",
    "Plain Mask": "普通面具",
    "Simple Earring Left": "左简单耳环",
    "Simple Earring Right": "右简单耳环",
    "Emerald earrings": "祖母绿耳环",
    "Moon earrings": "月亮耳环",
    "Pear earrings": "梨形耳环",
    "Princess earrings": "公主耳环",
    "Stud earrings": "耳钉",
    Bowtie: "蝴蝶结",
    "Bowtie 2": "蝴蝶结2",
    Necktie: "领带",
    Scarf: "围巾",
    Capeclip: "斗篷夹",
    Capetie: "斗篷带",
    Jabot: "领饰",
    Cravat: "领巾",
    Necklace: "项链",
    "Simple Necklace": "简单项链",
    "Chain Necklace": "链条项链",
    "Small Beaded Necklace": "小珠项链",
    "Large Beaded Necklace": "大珠项链",
    "Box Charm": "盒子吊坠",
    "Oval Charm": "椭圆吊坠",
    "Ring Charm": "戒指吊坠",
    "Star Charm": "星星吊坠",
    "Emerald cut Gem": "祖母绿切割宝石",
    "Marquise cut Gem": "榄尖形切割宝石",
    "Natural cut Gem": "自然切割宝石",
    "Pear cut Gem": "梨形切割宝石",
    "Pearl Gem": "珍珠宝石",
    "Princess cut Gem": "公主切割宝石",
    "Round cut Gem": "圆形切割宝石",
    "Trilliant cut Gem": "三角形切割宝石",
    "Cross amulet": "十字架护身符",
    "Dangling amulet": "悬挂护身符",
    "Spider amulet": "蜘蛛护身符",
    Plate: "板甲",
    Leather: "皮革",
    Epaulets: "肩章",
    Mantal: "斗篷",
    Armour: "盔甲",
    Bauldron: "护肩",
    Bracers: "护腕",
    Cuffs: "袖口",
    "Lace Cuffs": "蕾丝袖口",
    Gloves: "手套",
    "Stud Ring": "钉戒",
    "Sash dress": "腰带裙",
    "Slit dress": "开叉裙",
    Bodice: "紧身胸衣",
    Kimono: "和服",
    "Split Kimono": "开叉和服",
    "Child shirts": "儿童衬衫",
    Longsleeve: "长袖",
    Scoop: "圆领",
    "Collared/Formal Longsleeve": "有领/正式长袖",
    "Striped Collared/Formal Longsleeve": "条纹有领/正式长袖",
    "Longsleeve laced": "系带长袖",
    "Longsleeve 2": "长袖2",
    "Longsleeve 2 VNeck": "V领长袖2",
    "Longsleeve 2 Scoop": "圆领长袖2",
    "Longsleeve 2 Buttoned": "纽扣长袖2",
    "Longsleeve Polo": "长袖POLO衫",
    Cardigan: "开衫",
    Shortsleeve: "短袖",
    "Shortsleeve Polo": "短袖POLO衫",
    TShirt: "T恤",
    "TShirt VNeck": "V领T恤",
    "TShirt Scoop": "圆领T恤",
    "TShirt Buttoned": "纽扣T恤",
    Sleeveless: "无袖",
    "Sleeveless laced": "系带无袖",
    "Sleeveless striped": "条纹无袖",
    Tanktop: "背心",
    "Sleeveless 2": "无袖2",
    "Sleeveless 2 VNeck": "V领无袖2",
    "Sleeveless 2 Scoop": "圆领无袖2",
    "Sleeveless 2 Buttoned": "纽扣无袖2",
    "Sleeveless 2 Polo": "POLO无袖2",
    Corset: "紧身衣",
    Blouse: "女衬衫",
    "Longsleeve blouse": "长袖女衬衫",
    Tunic: "长袍",
    "Sara Tunic": "萨拉长袍",
    Robe: "长袍",
    Overalls: "工装裤",
    Suspenders: "背带",
    Apron: "围裙",
    "Apron half": "半身围裙",
    "Apron full": "全身围裙",
    Bandages: "绷带",
    Chainmail: "锁子甲",
    "Collared coat": "有领外套",
    "Iverness cloak": "因弗内斯斗篷",
    "Trench coat": "风衣",
    Tabard: "短外套",
    "Frock coat": "礼服外套",
    "Santa coat": "圣诞外套",
    "Frock collar": "礼服领",
    "Frock coat lace": "蕾丝礼服外套",
    "Frock coat lapel": "礼服外套翻领",
    "Frock coat buttons": "礼服外套纽扣",
    "Jacket pockets": "外套口袋",
    Vest: "背心",
    "Vest open": "开襟背心",
    Solid: "实心",
    Tattered: "破烂",
    "Cape Trim": "斗篷装饰",
    Backpack: "背包",
    "Square pack": "方形包",
    Jetpack: "喷气背包",
    Basket: "篮子",
    Quiver: "箭袋",
    "Leather Belt": "皮带",
    "Double Belt": "双层皮带",
    "Loose Belt": "松散皮带",
    "Belly belt": "腰带",
    "Other belts": "其他腰带",
    Sash: "腰带",
    "Narrow sash": "窄腰带",
    Waistband: "腰带",
    Buckles: "扣子",
    Obi: "和服腰带",
    "Obi Knot Left": "左和服腰带结",
    "Obi Knot Right": "右和服腰带结",
    "Wide pants": "宽裤子",
    Pants: "裤子",
    "Long Pants": "长裤",
    "Cuffed Pants": "翻边裤",
    Pantaloons: "灯笼裤",
    "Formal Pants": "正装裤",
    "Striped Formal Pants": "条纹正装裤",
    "Fur Pants": "毛皮裤",
    "Pregnancy pants": "孕妇裤",
    "Child pants": "儿童裤",
    Leggings: "紧身裤",
    "Leggings 2": "紧身裤2",
    Hose: "长袜",
    Shorts: "短裤",
    "Short Shorts": "超短裤",
    "Child skirts": "儿童裙子",
    "Plain skirt": "普通裙子",
    "Slit skirt": "开叉裙",
    "Legion skirt": "军团裙",
    "Straight skirt": "直筒裙",
    "Belle skirt": "贝尔裙",
    Overskirt: "罩裙",
    "Basic Shoes": "基础鞋",
    "Revised Shoes": "修改版鞋",
    "Sara Shoes": "萨拉鞋",
    Ghillies: "吉利鞋",
    "Basic Boots": "基础靴子",
    "Revised Boots": "修改版靴子",
    "Folded Rim Boots": "折边靴子",
    "Rimmed Boots": "边缘靴子",
    Slippers: "拖鞋",
    Sandals: "凉鞋",
    Hoofs: "蹄子",
    "Plated Toe": "金属包头",
    "Thick Plated Toe": "厚金属包头",
    "Ankle Socks": "短袜",
    "High Socks": "长袜",
    "Tabi Socks": "分趾袜",
    Rod: "棒",
    Smash: "砸",
    Thrust: "刺",
    Whip: "鞭子",
    Shield: "盾牌",
    Kite: "风筝盾",
    "Spartan shield": "斯巴达盾",
    "Two engrailed shield": "双凹盾",
    "Crusader shield": "十字军盾",
    "Plus shield": "加号盾",
    "Scutum shield": "长方盾",
    "Heater Shield Base": "基础三角盾",
    Crossbow: "弩",
    Slingshot: "弹弓",
    Dagger: "匕首",
    Glowsword: "发光剑",
    Longsword: "长剑",
    Rapier: "细剑",
    Saber: "军刀",
    Katana: "武士刀",
    Scimitar: "弯刀",
    "Longsword alt": "长剑替代版",
    "Arming Sword": "配剑",
    Cane: "手杖",
    Spear: "矛",
    Scythe: "镰刀",
    Halberd: "戟",
    "Long spear": "长矛",
    "Dragon spear": "龙矛",
    Trident: "三叉戟",
    "Simple staff": "简单法杖",
    "Loop staff": "环形法杖",
    "Diamond staff": "钻石法杖",
    "Gnarled staff": "扭曲法杖",
    "S staff": "S型法杖",
    Crystal: "水晶",
    Wand: "魔杖",
  },
  messages: {
    resetInfo: "切换体型将重置角色的所有装扮，您确定要继续吗？",
    randomizeInfo: "随机生成将重置角色的所有装扮，您确定要继续吗？",
    nameThisFigure: "给这个角色形象起个名字吧",
    unnamed: "未命名形象",
    newSprite: "新形象",
    nameRequired: "需要为角色形象起个名字才能保存哦",
    sureDeleteSprite: "确定删除这个角色形象吗？",
    createSprite: "创建角色形象",
    unsetSprite: "未创建角色形象",
    copyright: "版权声明",
  },
  bodyType: "体型",
  sprite: "形象",
};

const adoption = {
  title: "OC领养小院",
  publishAdoption: "发布领养",
  adoptable: "可领养",
  adopted: "已领养",
  collection: "收藏",
  collected: "已收藏",
  myAdoption: "我的领养",
  unlisted: "未上架",
  listed: "已上架",
  wantCount: "{count}人想要",
  originalOwner: "原主人",
  adopter: "领养人",
  pendingAdoption: "待领养",
  manuscriptCount: "稿件数量: {count}个",
  hasAi: "该角色包含AI辅助创作",
  noAi: "无AI创作",
  favorite: "收藏",
  adopt: "领养",
  secondaryCreation: "二次创作",
  creator: "创作者",
  all: "全部",
  original: "原创",
  fanswork: "二创",
  likes: "喜欢: {count}",
  tabs: {
    info: "资料",
    timeline: "时间线",
    randomThoughts: "随想",
    manuscripts: "稿件",
  },
  adoptionTitle: "领养标题",
  rules: {
    title: "请先填写领养标题",
    mate: "请先选择OC",
    powerCube: "请先填写领养门槛",
    powerCubeTooSmall: "领养门槛最低为10",
  },

  introduce: "介绍一下",
  selectPartner: "选择伙伴",
  aiAssisted: "是否包含AI辅助创作",
  isListed: "是否上架",
  adoptionThreshold: "领养门槛",
  adoptSuccess: "恭喜领养成功，正在跳转编辑页面查看",

  confirmAdopt: "确认领养",
  confirmAdoptTips: "确认领养该角色吗？",
};

const roleplay = {
  title: "答题",

  noMate: "您还没创建角色呢，快去创建一个吧",
};

const interactive = {
  dispatch: "外派",
  relationshipNetwork: "关系网",
  review: "审阅",
  mailbox: "信箱",
  handbook: "手帐",
  goods: "物品",
  task: "任务",
  ocInteractionPool: "互动池",
  poolTipsTitle: "加入互动池后，以下信息将对其他用户公开",
  poolTipsDesc: "OC的“基本信息”和“外貌特征”",
  running: "运行中",
  stopped: "已停止",
  twentyFourHourEstimatedConsumption: "最多消耗: {count}",
  perHour: "/小时",
  add: "添加",
  inTask: "任务中",
  onWandering: "遛弯中",
  inDaze: "发呆中",
  removeFromPool: "移出互动池",
  goToOC: "去 OC 主页",
  goToOCEdit: "编辑设定",
  viewMemory: "查看 OC 记忆球",

  house: {
    setting: {
      name: "互动设置",
      allowWandering: '允许OC发起"溜达"',
      allowWrite: '允许OC发起"写信"',
      allowPostMoment: '允许OC发起"发布饼友圈"',
      allowCommentMoment: '允许OC发起"评论饼友圈"',
      keepRunning: "应用关闭后，小屋继续运行",
    },
    consumption: {
      name: "互动池消耗",
      future: "每小时最多消耗",
      note: "请注意：审批列表中有待处理任务时，将暂停消耗能量。",
    },
  },
  reviewPage: {
    reviewed: "已审阅",
    unreviewed: "未审阅",
    settings: "设置",
    goToView: "去查看",
    expectRunMin: "预计执行时间: {count}分钟",
    invitation: {
      requestAddMate: "请求加好友",
      receivedInvitation: "收到好友邀请",
      invitationAccepted: "好友邀请已被接受",
      invitationRejected: "好友邀请已被拒绝",
      userRejected: "您已拒绝{name}为{targetName}发送好友邀请的请求",
      userApproved: "您已同意{name}为{targetName}发送好友邀请的请求",
      userRejectedInvitation:
        "您已拒绝{targetName}发送给{name}的好友邀请的请求",
      userApprovedInvitation:
        "您已同意{targetName}发送给{name}的好友邀请的请求",
    },
    mission: {
      requestSendMission: "请求发送任务",
      receivedMission: "收到任务邀请",
      missionSent: "任务已发送",
      missionDeleted: "任务已删除",
      userRejected: "您已拒绝{name}跟{targetName}一起做任务的请求",
      userApproved: "您已同意{name}跟{targetName}一起做任务的请求",
      userRejectedInvitation: "{targetName}已拒绝{name}一起做任务的请求",
      userApprovedInvitation: "{targetName}已同意{name}一起做任务的请求",
      goToSettle: "去迎接",
    },
    mail: {
      requestSendMail: "请求写信",
      receivedMail: "收到信件",
      mailSent: "信件已发送",
      mailDeleted: "信件已删除",
      userRejected: "您已拒绝{name}给{targetName}写信的请求",
      userApproved: "您已同意{name}给{targetName}写信的请求",
      subject: "信件标题",
      reciver: "收件人",
      sender: "发件人",
      agreeAndSend: "同意并寄出",
      expand: "展开",
      collapse: "收起",
      viewRelatedMails: "查看往来信件",
      mailHasReplied: "{name}已回复{targetName}的来信",
      mailHasNotReplied: "{name}还未回复{targetName}的来信",
    },
    stroll: {
      requestStroll: "请求出门溜达",
      strolled: "出门溜达了",
      return: "回来了",
      failed: "想去溜达，但是没能出门",
      userRejected: "您已拒绝{name}出门溜达的请求",
      strollDispatched: "溜达中",
      userApproved: "您已同意{name}出门溜达",
      goToSettle: "去迎接",
    },
    moment: {
      requestPostApproved: "您已同意{name}发布饼友圈的请求",
      requestPostRejected: "您已拒绝{name}发布饼友圈的请求",
      requestCommentApproved: "您已同意{name}评论饼友圈的请求",
      requestCommentRejected: "您已拒绝{name}评论饼友圈的请求",
      requestPost: "请求发布饼友圈",
      requestComment: "请求评论饼友圈",
    },
    history: {
      tabs: {
        all: "全部",
        read: "信件",
        mission: "外派",
        diary: "手帐",
        relationship: "关系",
      },
    },
  },
  joinInform: {
    title: "把OC放入互动池，让OC活起来！",
    desc: "加入互动池后，以下信息将对其他用户公开",
    selectOC: "选择OC",
    nextDay: "下次再说",
    neverShow: "不再提醒",
  },

  // 关系网相关翻译
  relationshipDetail: "关系详情",
  browseOtherOCs: "邂逅他人OC",
  myOCs: "我的OC",
  and: "和",
  eyesOf: "眼中的",
  actions: "动作",
  sendMail: "写信",
  inviteStroll: "邀请散步",
  inviteTask: "邀请做任务",
  inviteFriend: "邀请成为好友",
  cancelFriend: "取消好友",
  interactionSettings: "交互设置",
  interactionHistory: "交互历史",
  blockUser: "屏蔽{name}",
  blockDescription:
    "屏蔽 {targetName} 后，{sourceName} 将暂停与对方的所有互动往来，其邀请将被自动拒绝，信件会进入垃圾箱。",
  updateFailed: "更新失败",
  featureComingSoon: "功能即将上线",

  // 关系类型
  relationshipAcquaintance: "相识之人",
  relationshipBlocked: "厌恶之人",
  relationshipFriend: "朋友",
  relationshipCustom: "自定义关系",
  relationshipUnknown: "未知关系",
  relationshipUnnamed: "未命名关系",

  // 空状态提示
  noRelationshipsYet:
    "您的OC还未结识其他用户的OC，\n快派遣他们去探索，认识新伙伴吧！",
  sendThemToExplore: "发送他们去探索，结交新朋友吧！",
  yourOCsHaventMetOthers: "您的OC还没有遇见其他OC",
  sendYourOCsToExplore: "发送您的OC去探索，结交新朋友吧！",
  allOCs: "全部 OC",
  selectFilterOc: "选择筛选OC",
  dispatchOCs: "派遣OC",
  importOCs: "导入好友OC",
  importOCConfirm: "您在互动池的所有 OC 会与 {name} 变成相识之人，确定吗？",
  dispatchYourOCs: "派遣您的OC",
  addRelationship: "添加关系",
  addRelationshipTo: "添加与{name}的关系",
};

const mail = {
  inbox: "收件箱",
  sent: "已发送",
  draft: "草稿",
  trashed: "垃圾箱",
  threadbox: "往来信件",
  noMails: "您还没有收到任何信件",
  noSentMails: "您还没有发送任何信件",
  noDrafts: "您还没有草稿",
  noTrashMails: "您还没有删除任何信件",
  letter: "信件",
  letterFrom: "{name}的来信",
  letterTo: "给{name}的信件",
  subject: "信件标题",
  to: "收件人",
  from: "发件人",
  fromTips: `该信件经由
      <span class="text-primary">{ mateName }</span>
      的创作者
      <span class="text-primary">
        { userName }
      </span>
      审核后寄出`,
  selectSenderFirst: "选择发件人",
  selectRecipientFirst: "选择收件人",
};

const memory = {
  empty: "您还没有创建任何记忆球",
  type: {
    [MemoryType.Core]: "核心",
    [MemoryType.Scene]: "场景",
  },
  ball: {
    [MemoryCapacityLevel.Small]: "小型记忆球",
    [MemoryCapacityLevel.Medium]: "中型记忆球",
    [MemoryCapacityLevel.Large]: "大型记忆球",
    noMemory: "未加载",
  },

  capacityLevel: {
    [MemoryType.Core]: {
      [MemoryCapacityLevel.Small]: `小容量(${
        MemoryCapacityLevelMap[MemoryType.Core][MemoryCapacityLevel.Small]
      }字)`,
      [MemoryCapacityLevel.Medium]: `中容量(${
        MemoryCapacityLevelMap[MemoryType.Core][MemoryCapacityLevel.Medium]
      }字)`,
      [MemoryCapacityLevel.Large]: `大容量(${
        MemoryCapacityLevelMap[MemoryType.Core][MemoryCapacityLevel.Large]
      }字)`,
    },
    [MemoryType.Scene]: {
      [MemoryCapacityLevel.Small]: `小容量(${
        MemoryCapacityLevelMap[MemoryType.Scene][MemoryCapacityLevel.Small]
      }字)`,
      [MemoryCapacityLevel.Medium]: `中容量(${
        MemoryCapacityLevelMap[MemoryType.Scene][MemoryCapacityLevel.Medium]
      }字)`,
      [MemoryCapacityLevel.Large]: `大容量(${
        MemoryCapacityLevelMap[MemoryType.Scene][MemoryCapacityLevel.Large]
      }字)`,
    },
  },
};

const PowerCube = {
  title: "能量块账单",
  all: "全部",
  income: "收入",
  expense: "支出",
  empty: "暂无记录",
  relatedMate: "相关角色",
  selectType: "选择类型",
  selectCategory: "选择分类",
  excludeZero: "过滤免费",

  tab: {
    0: "全部",
    1: "收入",
    2: "支出",
  },

  category: {
    all: "全部分类",
    undefined: "筛选",
    [PowerCubeTransactionCategory.Recharge]: "充值",
    [PowerCubeTransactionCategory.ADReward]: "看广告收入",
    [PowerCubeTransactionCategory.ShareReward]: "分享收入",
    [PowerCubeTransactionCategory.DrawImage]: "生成图片",
    [PowerCubeTransactionCategory.DrawAvatar]: "生成头像",
    [PowerCubeTransactionCategory.InpaintImage]: "随画",
    [PowerCubeTransactionCategory.Chat]: "对话",
    [PowerCubeTransactionCategory.PublishAdoption]: "发布领养",
    [PowerCubeTransactionCategory.AdoptMate]: "领养角色",
    [PowerCubeTransactionCategory.AdoptionReward]: "领养奖励",
    [PowerCubeTransactionCategory.Dispatch]: "派遣任务",
    [PowerCubeTransactionCategory.JoinDispatch]: "加入派遣",
    [PowerCubeTransactionCategory.DispatchReward]: "派遣奖励",
    [PowerCubeTransactionCategory.DispatchRefund]: "派遣退款",
    [PowerCubeTransactionCategory.Wish]: "祈愿",
    [PowerCubeTransactionCategory.CompleteModule]: "OC写设定",
    [PowerCubeTransactionCategory.CompleteMoment]: "OC写随记",
    [PowerCubeTransactionCategory.CompleteReply]: "OC写回复",
    [PowerCubeTransactionCategory.CompleteMail]: "OC写信件",
    [PowerCubeTransactionCategory.CompleteRoleplayAnswer]: "OC写问答",
    [PowerCubeTransactionCategory.GenerateInteractionRequest]: "互动事件请求",
    [PowerCubeTransactionCategory.GenerateDispatchObjective]: "任务目标评估",
    [PowerCubeTransactionCategory.VoteRanking]: "投票",
    [PowerCubeTransactionCategory.ConvertTextToSpeech]: "语音生成",
    [PowerCubeTransactionCategory.DecomposeEquipment]: "分解装备",
    [PowerCubeTransactionCategory.OpenChest]: "打开宝箱",
    [PowerCubeTransactionCategory.PurchaseChest]: "购买宝箱",
    [PowerCubeTransactionCategory.ExtractMemory]: "提取记忆",
    [PowerCubeTransactionCategory.GenerateTreeHoleComment]: "树洞评论",
    [PowerCubeTransactionCategory.GenerateSprite]: "形象生成",
    [PowerCubeTransactionCategory.GenerateSpriteAnimation]: "形象小人生成",
    [PowerCubeTransactionCategory.MateHouseSessionMessage]: "角色小屋对话",
    [PowerCubeTransactionCategory.GenerateSpritePortrait]: "形象立绘",
    [PowerCubeTransactionCategory.GenerateHouseSessionEvent]: "小屋事件",
    [PowerCubeTransactionCategory.SpriteGenerationRefund]: "形象退款",
    [PowerCubeTransactionCategory.GenerateMate]: "生成角色",
    [PowerCubeTransactionCategory.MateGenerationRefund]: "角色生成退款",
    [PowerCubeTransactionCategory.SpritePortraitGenerationRefund]:
      "立绘生成退款",
    [PowerCubeTransactionCategory.GenerateSpriteFullAnimation]: "全套形象",
    [PowerCubeTransactionCategory.GenerateSpriteAvatar]: "生成形象头像",
    [PowerCubeTransactionCategory.SpriteAvatarGenerationRefund]: "头像生成退款",
    [PowerCubeTransactionCategory.MemberSubscriptionGift]: "会员订阅礼物",
    [PowerCubeTransactionCategory.WishRefund]: "祈愿退款",
    [PowerCubeTransactionCategory.UserTaskReward]: "完成任务奖励",
  },
};

const house = {
  restAvaiableCharacter: "选择放入小屋的伙伴",
  selectCharacterInHouse: "选择在小屋中的角色",
  maxCharacterCount: "小屋中最多放入{count}个角色",
  cancelSelectedCharacter: "请先取消选中一个角色后，再选择新的角色",
  manageMembers: "管理成员",
  member: "成员",
  thoughts: "对话",
  relationship: "关系",
  subject: "话题",
  events: "事件",
  houseSubject: "小屋情景",
  referSubject: "参考情景",
  noNewThoughts: "暂时没有新的想法",
  newestThought: "最新想法",
  recentThoughts: "近期想法",
  status: "状态",
  thinking: "思考",
  strolling: "闲逛",
  active: "已激活",
  inactive: "未激活",
  activeToThinking: "激活后将会产生想法",
  cost: "每个想法消耗",
  costPerSec: "每分钟消耗",
  perMin: "每分钟",
  leavePage: "离开本停止消耗",
  mateWithoutSprite: "没有形象的角色",
  subjectPanel: {
    charCostTip: "字符内无额外消耗",
    charCostTip2: "小屋中的每条消息将会多消耗",
    changeSubjectTip: "您已更换情景，是否需要清空之前的所有对话？",
    changeAndClear: "更换并清空",
    changeOnly: "仅更换",
    cancel: "取消",
  },
  relationshipPanel: {
    house: "小屋",
    all: "所有伙伴",
  },
  invite: "创建伙伴",
  memberManage: "成员管理",
  portraitPreview: "立绘预览",
  actions: "行动",
  thought: "想法",
  interaction: "互动",
  thoughtToggle: {
    title: "{toggle}所有角色的思考状态",
    activeTip: "激活后，所有角色将进入思考状态",
    deactiveTip: "关闭后，所有角色将退出思考状态",
    active: "激活",
    deactive: "关闭",
  },
  interactToggle: {
    title: "{toggle}所有角色的互动状态",
    activeTip: "激活后，开启互动的角色会发起互动请求",
    deactiveTip: "关闭后，开启互动的角色将无法发起互动请求",
    active: "激活",
    deactive: "关闭",
  },
  insufficientPower: {
    title: "能量块不足",
    message: "开启后您的角色可能仍无法进入思考状态",
    confirmButtonText: "兑换能量块",
    cancelButtonText: "下次再说",
  },
};
const treehole = {
  msg: "向树洞说句悄悄话，无论是随口一提的碎碎念，还是藏在心底的小情绪，与你连接的角色都会认真倾听",
  say: "讲悄悄话",
  connect: "连接",
  myConnect: "连接的伙伴",
  placeholder: "你的悄悄话，只能被你连接的角色听到",
  currentSelf: "当前自设",
  connectWithMe: "与我连接的伙伴",
  actived: "已激活",
  unactived: "未激活",
  cost: "每条响应消耗",
  moreRole: "更多角色",
  selectConnect: "选择要连接的角色",
};

const chat = {
  model: {
    [LanguageModel.QwenFlash]: {
      name: "入门版",
      desc: "基础功能，成本低",
    },
    [LanguageModel.Qwen30bA3b]: {
      name: "轻享版",
      desc: "快速响应，成本低",
    },
    [LanguageModel.QwenMax]: {
      name: "标准版",
      desc: "高性价比，质量与价格兼具",
    },
    [LanguageModel.GeminiFlash]: {
      name: "进阶版",
      desc: "价格较贵，高质量回复",
    },
    // [LanguageModel.GeminiPro]: {
    //   name: "尊享版",
    //   context: "1000k tokens",
    // },
  },
};

const sprite = {
  create: "创建形象",
  step: {
    1: "1. 创建你的形象",
    2: "2. 确认注册信息",
  },
  generating: "正在生成中...您可以离开页面<br />生成完成后您会收到通知",
  currentGender: "当前性别",
  nameAndSpriteCanBeChanged: "名称和形象可以随时更改",
  displayInHouseEvent: "在小屋事件中显示",
  portrait: "立绘",
  avatar: "头像",
  displayInHouseDialog: "在小屋对话中显示",
  frame: "像素小人",
  allImage: "全部形象",
  image: "形象",
  displayInHouseFrame: "在小屋中显示",
  useReferenceImage: "使用参考图",
  presetSprite: "预设形象",
  all: "全部",
  male: "男",
  female: "女",
  custom: "自定义",
  selectImage: "选择图片",
  change: "更换",
  generateNow: "立即生成",
  regenerate: "重新生成",
  includePortraitAndAvatarAndFrame: "包含立绘、放大头像、像素小人",
  promptDescription: "补充描述",
  promptDescriptionPlaceholder: "请输入对于该图片的补充描述",
  pleaseWaitTaskComplete: "请等待任务完成",
  updatingReferenceImage: "正在更新参考图...",
  updatingAvatar: "正在更新头像...",
  updatingPortrait: "正在更新立绘...",
  pleaseSelectReferenceImage: "请先选择参考图",
  creatingNewSprite: "正在创建新形象...",
  pleaseCompleteCreationBeforeEditing: "请先完成创建后再进行编辑",
  confirmDelete: "确定要删除{type}吗？",
  deletingPortrait: "正在删除立绘...",
  deletingAvatar: "正在删除头像...",
  pleaseSelectPresetSprite: "请先选择预设形象",
  creating: "正在创建...",
  createSuccess: "创建成功",
  pleaseEnterSpriteName: "请输入形象名称",
  pleaseGenerateSprite: "请先生成角色形象",
  preparingToEnterYourHouse: "正在准备进入你的小屋~...",
  generateUsingReferenceImage: "使用参考图生成",
  generateUsingPortraitImage: "参考立绘图生成",
  generateUsingAvatarImage: "参考头像图生成",
  generateFromEditor: "从编辑器生成",
  editSingleFrame: "编辑单帧图",
  editPixelSprite: "编辑像素小人",
  spriteGenerationCompleted: "形象生成完成",
  needCloth: "形象需要有衣服哦～",
  uploadFrame: "上传该帧",
  regenerate1: "重新生成(消耗1能量块)",
  pleaseUpload48x96Image: "请上传48*96像素的图片",
  unsavedOperation:
    "您有未保存的操作，重新生成会导致这些操作丢失。若需保留，请先保存；确认放弃并重新生成吗？",
  confirmRegenerateDirection: "确定要重新生成该动作吗？",
  confirmRegenerateAll: "确定要全部重新生成吗？",
  saving: "正在保存...",
  saveSuccess: "保存成功",
  generationResult: "生成结果",
  detailAdjustment: "细节调整",
  regenerateDirection: "重新生成",
  spriteEditor: "像素编辑器",
  modifyFrame: "修改该帧",

  confirmGenerate: "确定生成将会覆盖原有的{type}，是否继续？",
  confirmOverwrite: "确定覆盖",
  createNewAndContinue: "创建新形象，继续任务",
  newImageCreation: "新形象创建中...",
};

const mbti = {
  e: "外向",
  i: "内向",
  s: "感觉",
  n: "直觉",
  t: "思维",
  f: "情感",
  j: "判断",
  p: "知觉",

  intj: {
    name: "建筑师",
    nickname: "策略家",
    description:
      "富有想象力和战略性的思想家，一切皆有计划。他们独立、有决心、对自己和他人都有很高标准。",
    traits: "独立自主,富有远见,善于规划,追求完美,理性分析",
  },
  intp: {
    name: "思想家",
    nickname: "逻辑学家",
    description:
      "具有创造性的思想家，对知识充满渴望。他们善于思考抽象概念，喜欢理论和创新。",
    traits: "逻辑性强,善于分析,富有创意,求知欲强,独立思考",
  },
  entj: {
    name: "指挥官",
    nickname: "统帅",
    description: "大胆、富有想象力、意志强烈的领导者，总能找到或创造解决办法。",
    traits: "天生领导,决策果断,目标明确,组织能力强,自信进取",
  },
  entp: {
    name: "辩论家",
    nickname: "发明家",
    description:
      "聪明好奇的思想家，不会拒绝任何智力上的挑战。他们善于发现可能性和联系。",
    traits: "思维敏捷,善于辩论,富有创新,适应性强,乐观外向",
  },
  infj: {
    name: "提倡者",
    nickname: "咨询师",
    description:
      "富有创造性和洞察力的理想主义者，以原则和道德为动力。他们寻求意义和真实的联系。",
    traits: "富有同情心,洞察力强,理想主义,坚持原则,追求和谐",
  },
  infp: {
    name: "调停者",
    nickname: "治愈者",
    description:
      "诗意的、善良的利他主义者，总是期待着做好事的机会。他们忠于自己的价值观。",
    traits: "价值观明确,富有创意,善解人意,适应性强,真诚善良",
  },
  enfj: {
    name: "主人公",
    nickname: "教师",
    description:
      "富有魅力、鼓舞人心的领导者，善于让听众全神贯注。他们关心他人的成长。",
    traits: "富有魅力,善于激励,关心他人,组织能力强,理想主义",
  },
  enfp: {
    name: "竞选者",
    nickname: "冠军",
    description:
      "热情、有创造力、爱社交的自由精神，总能找到笑的理由。他们充满活力和热情。",
    traits: "热情洋溢,富有创意,社交能力强,乐观积极,适应性强",
  },
  istj: {
    name: "物流师",
    nickname: "检查员",
    description: "实用主义的事实爱好者，可靠性毋庸置疑。他们重视传统和忠诚。",
    traits: "责任心强,注重细节,守时守信,实事求是,条理清晰",
  },
  isfj: {
    name: "守护者",
    nickname: "保护者",
    description:
      "非常专注、温暖的守护者，时刻准备保护爱的人。他们善良、负责任。",
    traits: "善良体贴,责任心强,保护欲强,注重和谐,默默奉献",
  },
  estj: {
    name: "总经理",
    nickname: "主管",
    description:
      "出色的管理者，在管理事物或人员方面无与伦比。他们重视传统和秩序。",
    traits: "组织能力强,执行力强,重视秩序,目标导向,决策果断",
  },
  esfj: {
    name: "执政官",
    nickname: "供应者",
    description:
      "极度关心他人的人，善于社交，非常受欢迎。他们热心助人、忠诚可靠。",
    traits: "热心助人,善于合作,关心他人,责任心强,重视和谐",
  },
  istp: {
    name: "鉴赏家",
    nickname: "工匠",
    description: "大胆而实际的实验家，擅长各种工具的使用。他们冷静、适应性强。",
    traits: "动手能力强,冷静理性,适应性强,独立自主,实用主义",
  },
  isfp: {
    name: "探险家",
    nickname: "艺术家",
    description:
      "灵活的、有魅力的艺术家，时刻准备探索新的可能性。他们温和、敏感。",
    traits: "艺术天赋,温和友善,灵活适应,注重美感,价值观明确",
  },
  estp: {
    name: "企业家",
    nickname: "推广者",
    description:
      "聪明、精力充沛、善于理解他人的真正推销员。他们热爱生活、善于社交。",
    traits: "精力充沛,善于社交,实用主义,适应性强,行动导向",
  },
  esfp: {
    name: "娱乐家",
    nickname: "表演者",
    description:
      "自发的、精力充沛、热情的人，生活对他们来说从不无聊。他们温暖、友善。",
    traits: "热情开朗,善于表达,社交能力强,乐观积极,注重体验",
  },
};

export default {
  Moment,
  Reply,
  Message,
  Language,
  Texts,
  loginmodal,
  card,
  Chats,
  ChatCast,
  Newmates,
  User,
  Menus,
  Buttons,
  Tabs,
  Titles,
  Media,
  Community,
  Overview,
  Notifications,
  Empty,
  ConfirmModal,
  MateType,
  Visibilities,
  trait,
  painting,
  task,
  story,
  SidebarNavi,
  Social,
  MineMate,
  Request,
  Cell,
  bgm,
  game,
  ReloadPrompt,
  Home,
  Image,
  Animation,
  Config,
  Coin,
  rank,
  Payment,
  collection,
  share,
  contactUs,
  nsfw,
  purchase,
  setting,
  translate,
  About,
  helper,
  tag,
  Dungeons,
  Time,
  HEAD,
  homeGreeting,
  invitation,
  module: mateModule,
  characterGenerator,
  mission,
  mateWish,
  adoption,
  roleplay,
  interactive,
  mail,
  memory,
  house,
  treehole,
  chat,
  sprite,
  mbti,
  PowerCube,
  userTask,
};
